import common from './common'
import featuresPay from './feature'

const ar = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "المنتج/المتغيرات",
        serialNumber: "الرقم التسلسلي",
        noProductsFound: "لم يتم العثور على منتجات",
        searchByProductSku: "البحث حسب المنتج/SKU",
        searchSerialNumbers: "البحث في الأرقام التسلسلية",
        transactionDetails: "تفاصيل المعاملة",
        notAvailable: "غير متوفر",
        mainWarehouse: "المستودع الرئيسي"
    },
    new_build_banner: {
        title: 'نسخة جديدة:',
        is_available: 'متوفرة الآن',
        fallback_title: 'نسخة جديدة من التطبيق متوفرة',
        desc: 'قم بالتحديث للحصول على أحدث الميزات والتحسينات.',
        refreshing: 'جاري التحديث…',
        refresh_now: 'تحديث الآن',
        later: 'لاحقاً',
        you_are_on: "أنت تستخدم"
    },
    short: {
        finance: 'المالية',
        stock: 'المخزون'
    },
    onboarding: {
        welcome: 'مرحبًا!',
        step: {
            product: {
                totalBreakdown: 'التفاصيل الإجمالية',
                overallFulfilment: 'الإنجاز العام',
                totalShippedQty: 'إجمالي الكمية المشحونة',
                totalReceivedQty: 'إجمالي الكمية المستلمة',
                totalOrderedQty: 'إجمالي الكمية المطلوبة',
                totalShippedOrdered: 'إجمالي المشحون / المطلوب',
                totalReceivedOrdered: 'إجمالي المستلم / المطلوب',
                viewQty: 'عرض الكمية',
                fetchingQty: 'جاري جلب تفاصيل الكمية...',
                noStockInfo: 'لم يتم العثور على معلومات المخزون',
                title: '65% مكتمل',
                description: 'تبقى خطوتان فقط لبدء نجاحك العظيم!',
                Warehouse: "المستودع",
},
            stock: {
                title: '95% شبه مكتمل!!',
                description: 'تبقى خطوة واحدة فقط لبدء نجاحك العظيم! أكملها الآن.'
            }
        },
        business: {
            title: 'تم إنشاء العمل بنجاح!',
            description: 'رائع! تم تسجيل عملك'
        },
        product: {
            title: 'أضف منتجك الأول',
            description: 'أضف منتجًا لبدء تسجيل المخزون',
                Warehouse: "المستودع",
},
        stock: {
            title: 'جرّب إضافة مخزون',
            description: 'ابدأ بتسجيل المخزون الداخل والخارج'
        },
        action: {
            add_business: {
                title: 'إنشاء عمل',
                description: 'هل ترغب في إنشاء عمل جديد؟ انقر هنا'
            },
            join_business: {
                title: 'الانضمام إلى العمل',
                description: 'هل لديك رمز دعوة؟ انضم هنا'
            }
        }
    },
    business: {
        title: 'اختر عملاً، أنشئ جديدًا، أو انضم',
        add_business: {
            title: 'إنشاء عمل جديد',
            name: 'اسم العمل',
            name_placeholder: 'أدخل الاسم',
            category: 'فئة العمل',
            category_placeholder: 'اختر الفئة',
            button: 'إنشاء العمل'
        },
        edit_business: {
            title: 'تعديل العمل'
        },
        join_business: {
            title: 'الانضمام إلى العمل',
            input_code: 'أدخل رمز الدعوة أدناه:',
            field_placeholder: 'رمز الدعوة',
            confirm_title: 'انضم',
            confirm_text: 'ستصبح جزءًا من الفريق في '
        },
        no_business: 'لا توجد أعمال متاحة',
        create_or_join: 'إنشاء عمل أو الانضمام إليه',
        message: {
            saved: 'تم حفظ العمل بنجاح!'
        },
        settings: {
            isNegativeTransactionDisabled: 'معاملات المخزون السلبي',
            isNegativeTransactionDisabledHint: 'بتفعيل هذا الخيار، يمكنك منع المعاملات التي قد تؤدي إلى مخزون سلبي.',
            negativeStockError: 'معاملات المخزون السلبي معطلة'
        }
    },
    profile: {
        edit_profile: {
            title: 'تعديل الملف الشخصي',
            name: 'الاسم الكامل',
            name_placeholder: 'أدخل الاسم الكامل',
            email: 'البريد الإلكتروني',
            phone_number: 'رقم الهاتف'
        },
        message: {
            required_name: 'الاسم مطلوب'
        }
    },
    product: {
        weightedAverageCost: 'متوسط التكلفة المرجح',
        weightedAverageValueLabel: 'القيمة المتوسطة المرجحة',
        Product: 'المنتج',
        hideZeroStock: 'إخفاء المنتجات بدون مخزون',
        allVariants: 'جميع المتغيرات',
        choose_product: 'اختر المنتج',
        choose_product_empty: 'حدد المنتج وأدخل الكمية',
        search: {
            placeholder: 'ابحث بالاسم',
            tooltip: 'فتح الماسح الضوئي',
            Warehouse: "المستودع",
},
        column: {
            invoice: "فاتورة",
            image: 'صورة',
            name: 'الاسم',
            price: 'السعر',
            buying_price: 'سعر التكلفة',
            selling_price: 'سعر البيع',
            sku: 'رمز المنتج',
            stock: 'المخزون',
            quantity: 'الكمية',
            latest_stock: 'المتبقي',
            product_deleted: 'تم حذف المنتج',
            info_not_found: 'المعلومات غير متاحة',
            expired_date: 'تاريخ انتهاء الصلاحية'
        },
        no_product: 'لا توجد منتجات متاحة',
        no_product_subtitle: 'أضف منتجك الأول لبدء تتبع المخزون والأسعار والمبيعات.',
        create_first_product: 'أنشئ منتجك الأول',
        add_product: {
            sku: 'رمز المنتج',
            sku_placeholder: 'رمز المنتج. مثال: 12345',
            name: 'اسم المنتج',
            name_placeholder: 'أدخل اسم المنتج',
            initial_stock: 'المخزون الأولي',
            initial_stock_placeholder: 'أدخل المخزون الأولي',
            buying_price: 'سعر التكلفة',
            buying_price_placeholder: 'أدخل سعر التكلفة',
            selling_price: 'سعر البيع',
            selling_price_placeholder: 'أدخل سعر البيع',
            category: 'الفئة',
            category_placeholder: 'اختر الفئة',
            add_selling_price: 'أضف سعر الجملة',
            expired_date: 'تاريخ انتهاء الصلاحية',
            expired_date_placeholder: 'اختر التاريخ',
            description: 'الوصف',
            description_placeholder: 'أدخل الوصف',
            Warehouse: "المستودع",
},
        choose_selling_price: 'اختر سعر البيع',
        selling_price: 'سعر البيع',
        total_product: 'إجمالي المنتجات',
        total_quantity: 'إجمالي المخزون',
        total_buying_price: 'إجمالي سعر التكلفة',
        total_selling_price: 'إجمالي سعر البيع',
        message: {
            required_name: 'اسم المنتج مطلوب',
            required_sku: 'رمز المنتج مطلوب',
            required_category: 'الفئة مطلوبة',
            required_quantity: 'المخزون الأولي مطلوب',
            invalid_input_qty: 'كمية المخزون غير صالحة',
            required_buying_price: 'سعر التكلفة مطلوب',
            required_selling_price: 'سعر البيع مطلوب',
            required_selling_price_name: 'اسم سعر البيع مطلوب',
            required_selling_price_price: 'سعر البيع مطلوب'
        },
        viewMore: 'عرض المزيد',
        WarehouseDetails: 'تفاصيل المستودع',
        WarehouseName: 'اسم المستودع',
        AddWarehouse: 'إضافة مستودع',
        WarehouseQty: 'كمية المستودع',
        Warehouse: 'المستودع',
        Warehouses: 'المستودعات',
        Variants: 'المتغيرات',
        VariantName: 'اسم المتغير',
        productVariant: 'متغيرات المنتج',
        AddVariant: 'إضافة متغيرات',
        TranferItem: 'نقل العناصر',
        AddUnit: 'وحدة جديدة',
        InitialStkWarehouse: 'المخزون الأولي المطلوب لإضافة المتغيرات',
        InitialStockinwarehouse: 'المخزون الأولي في المستودع',
        TotalQuantity: 'إجمالي الكمية:',
        AddNote: 'إضافة ملاحظة (سعر التكلفة)',
        AddNotetitle: 'إضافة ملاحظة',
        VariantSuccessMessage: 'تم تحديث متغير المنتج بنجاح',
        Next: 'التالي',
        Submit: 'إرسال',
        INACTIVE: 'غير نشط',
        errorone: 'عذرًا! الكمية المطلوبة لـ',
        errortwo: 'لا تتطابق مع كميات المستودع المخصصة. يرجى ضبط الكمية أو إعادة تخزينها.',
        SelectWarehouse: 'اختر المستودع',
        SelectVariant: 'اختر النوع',
        Discount: 'خصم',
        DiscountDetails: 'تفاصيل الخصم',
        FinalPrice: 'السعر النهائي',
        DiscountType: 'نوع الخصم',
        DiscountPer: 'خصم %',
        DiscountValue: 'قيمة الخصم',
        Discountonprice: 'خصم على السعر',
        Discountondiscount: 'خصم على الخصم',
        AdditionalDiscount: 'خصم إضافي',
        SellingPrice: 'سعر البيع:',
        Save: 'حفظ',
        OnOriginalPrice: 'على السعر الأصلي',
        OnDiscountedPrice: 'على السعر المخفض',
        columnSelector: {
            title: 'عرض الأعمدة',
            columnsButton: 'الأعمدة',
            costPrice: 'سعر التكلفة',
            sellingPrice: 'سعر البيع',
            sku: 'SKU',
            warehouse: 'المستودع',
            categories: 'الفئات',
            safetyStock: 'مخزون الأمان',
            attributes: 'الخصائص',
            notes: 'ملاحظات',
            description: 'الوصف',
            more: 'أكثر',
            attribute: 'خاصية',
            attributesTitle: 'خصائص',
            categoriesTitle: 'الفئات',
            skuAliases: 'أسماء SKU المستعارة'
        }
    },
    note: {
        title: 'ملاحظات',
        add: 'إضافة ملاحظة',
        no_note: 'لا توجد ملاحظات متاحة'
    },
    settings: {
        category: 'فئة',
        language: 'لغة',
        switch_business: 'تبديل الأعمال',
        currencySelect: 'العملة',
        languageChangeSuccess: "تم تحديث العملة بنجاح",
        languageChangeErrorMessage: "حدث خطأ أثناء تحديث العملة",
        currencyAdded: "تمت إضافة العملة بنجاح",
        currencyDelete: "تم حذف العملة بنجاح",
        Selectyourpreferredlanguage: "اختر لغتك المفضلة",

    },
    category: {
        category_list: {
            title: 'فئات المنتجات'
        },
        add_category: {
            button: 'فئة جديدة',
            title: 'إضافة فئة جديدة'
        },
        edit_category: {
            title: 'تعديل الفئة'
        },
        name: 'اسم الفئة',
        name_placeholder: 'أدخل اسم الفئة',
        no_category: 'لا توجد فئات متاحة'
    },
    staff: {
        add: 'إضافة موظف',
        edit: 'تعديل موظف',
        access: {
            stock: 'المخزون',
            add_product: 'إضافة منتج جديد',
            edit_product: 'تعديل المنتج',
            delete_product: 'حذف المنتج',
            view_capital_price: 'عرض سعر التكلفة',
            add_category: 'إضافة فئة جديدة',
            edit_category: 'تعديل الفئة',
            delete_category: 'حذف الفئة',
            add_supplier: 'إضافة مورد جديد',
            edit_supplier: 'تعديل المورد',
            delete_supplier: 'حذف المورد',
            add_customer: 'إضافة عميل جديد',
            edit_customer: 'تعديل العميل',
            delete_customer: 'حذف العميل',
            add_staff: 'إضافة موظف',
            edit_staff: 'تعديل الموظف',
            delete_staff: 'حذف الموظف',
            change_business_profile: 'تغيير ملف الأعمال',
            access_by_product_category: 'الوصول حسب فئة المنتج',
            no_category_message: 'ليس لديك أي فئة مضافة. يرجى إضافة فئة.',
            expenses: 'المصاريف',
            view_expenses: 'عرض المصاريف',
            add_expenses: 'إضافة مصاريف',
            edit_expenses: 'تعديل المصاريف',
            delete_expenses: 'حذف المصاريف',
            warehouse: 'المستودع',
            add_new_warehouse: 'إضافة مستودع جديد',
            edit_warehouse: 'تعديل المستودع',
            delete_warehouse: 'حذف المستودع',
            transfer_warehouse: 'نقل المستودع',
            transfer_warehouse_approval: 'الموافقة على نقل المستودع',
            access_by_warehouse: 'الوصول حسب المستودع',
            no_warehouse_message: 'ليس لديك أي مستودع مضاف. يرجى إضافة قائمة المستودعات.',
            purchase_order: "أمر شراء",
            purchase_order_creation: "إنشاء أمر شراء",
            purchase_order_edit: "تعديل أمر شراء",
            purchase_order_cancel: "إلغاء أمر شراء",
            purchase_order_reopen: "إعادة فتح أمر شراء",
            purchase_order_receive: "استلام أمر شراء",
            sales_order: "أمر بيع",
            sales_order_creation: "إنشاء أمر بيع",
            sales_order_edit: "تعديل أمر بيع",
            sales_order_cancel: "إلغاء أمر بيع",
            sales_order_reopen: "إعادة فتح أمر بيع",
            sales_order_receive: "تم شحن أمر البيع",
            purchase_order_approval: "الموافقة على أمر الشراء",
            sales_order_approval: "الموافقة على أمر البيع",
            can_do_available_warehouse: "المستودع المتاح",
            add_batch: "الموافقة على إنشاء الدفعة"
            ,
            notification: 'إشعار',
            staffNotification: 'تمكين الإشعارات',
        assignee: "المكلف",
    },
        no_staff: 'لا يوجد موظفون متاحون.'
    },
    code: {
        title: 'تم إضافة موظف جديد!',
        subtitle: 'شارك رمز الدعوة أدناه للانضمام:',
        valid: 'الرمز صالح لمدة 48 ساعة فقط',
        share: 'مشاركة على واتساب',
        copied: 'تم النسخ!',
        invalid: 'رمز غير صالح!'
    },
    history: {
        no_history: 'لا توجد تاريخ.',
        detail: {
            remove: 'إزالة التاريخ',
            confirm: 'ستؤثر هذه الميزة على المخزون الحالي والتاريخ والتقارير.'
        },
        no_history_selected: "لم يتم اختيار أي سجل",
        select_history_hint: "انقر على سجل من القائمة لعرض التفاصيل",
        select_from_left: "اختر من اللوحة اليسرى",
    },
    supplier: {
        add: {
            title: 'إضافة بائع'
        },
        edit: {
            title: 'تعديل بائع'
        },
        new: 'بائع جديد',
        no_supplier: 'لا توجد بائعين متاحين.',
        bank: {
            title: 'تفاصيل البنك'
        },
        note: 'ملاحظات',
        form: {
            name: {
                label: 'اسم البائع',
                placeholder: 'أدخل اسم البائع',
                placheolder_not_mandatory: 'أدخل الاسم ',
                error: {
                    required: 'لا يمكن أن يكون الاسم فارغاً'
                }
            },
            contact: {
                label: 'رقم الاتصال',
                placeholder: '91934554432',
                error: {
                    required: 'لا يمكن أن يكون رقم الاتصال فارغاً',
                    invalid: 'رقم غير صالح. يجب أن يتضمن رمز الدولة'
                }
            },
            bank_name: {
                label: 'اسم البنك',
                placeholder: 'أدخل اسم البنك'
            },
            bank_account_name: {
                label: 'اسم صاحب الحساب',
                placeholder: 'أدخل اسم صاحب الحساب'
            },
            bank_account_number: {
                label: 'رقم الحساب',
                placeholder: 'أدخل رقم الحساب'
            },
            note: {
                label: 'ملاحظات',
                placeholder: 'أضف ملاحظات'
            },
            openingBalance: {
                addBtn: 'إضافة الرصيد الافتتاحي',
                label: 'الرصيد الافتتاحي',
                placeholder: 'أدخل الرصيد الافتتاحي',
                error: {
                    negative: 'لا يمكن أن يكون الرصيد الافتتاحي سالبًا'
                }
            }
        },
        choose: 'اختر البائع'
    },
    customer: {
        add: {
            title: 'إضافة عميل'
        },
        edit: {
            title: 'تعديل عميل'
        },
        new: 'عميل جديد',
        no_customer: 'لا توجد عملاء متاحين.',
        note: 'ملاحظات',
        form: {
            name: {
                label: 'اسم العميل',
                placeholder: 'أدخل اسم العميل',
                placheolder_not_mandatory: 'أدخل الاسم',
                error: {
                    required: 'لا يمكن أن يكون الاسم فارغاً'
                }
            },
            contact: {
                label: 'رقم الاتصال',
                placeholder: '91934554432',
                error: {
                    required: 'لا يمكن أن يكون رقم الاتصال فارغاً',
                    invalid: 'رقم غير صالح. يجب أن يتضمن رمز الدولة'
                }
            },
            address: {
                label: 'العنوان',
                placeholder: 'أدخل العنوان'
            },
            note: {
                label: 'ملاحظات',
                placeholder: 'أضف ملاحظات'
            },
            openingBalance: {
                addBtn: 'إضافة الرصيد الافتتاحي',
                label: 'الرصيد الافتتاحي',
                placeholder: 'أدخل الرصيد الافتتاحي',
                error: {
                    negative: 'لا يمكن أن يكون الرصيد الافتتاحي سالبًا'
                }
            }
        },
        choose: "اختر العميل",
        report: {
            view: 'عرض تقرير المشتري',
            title: 'تقرير المشتري',
            no_report: 'لا توجد تقارير للمشترين في التاريخ المحدد.',
            column: {
                name: 'الاسم',
                total_transaction: 'إجمالي المعاملات',
                total_amount: 'إجمالي المبيعات',
                total_profit: 'إجمالي الربح'
            }
        }
    },
    confirm_delete: 'هل أنت متأكد أنك تريد حذف هذه البيانات؟',
    report: {
        title: 'التقرير'
    },
    accounting: {
        download_pdf_report: 'تنزيل PDF',
        title: 'المحاسبة',
        view_report: 'عرض التقرير المالي',
        dashboard_title: 'التقرير المالي',
        stats: 'الإحصائيات',
        accounting_report: 'تقرير المحاسبة',
        filter: {
            date: {
                placeholder: 'اختر التاريخ',
                submit: 'تطبيق',
                cancel: 'إعادة تعيين الفلتر'
            },
            timeframe: {
                day: 'يومي',
                week: 'أسبوعي',
                month: 'شهري',
                year: 'سنوي'
            }
        },
        total_sales: 'إجمالي المبيعات',
        total_purchases: 'إجمالي المشتريات',
        total_profit: 'إجمالي الربح',
        total_expenses: 'إجمالي المصروفات',
        assets_value: 'قيمة الأصول الحالية',
        total_current_cogs_value: 'إجمالي قيمة تكلفة البضاعة المباعة الحالية',
        current_asset_selling_price: 'سعر بيع الأصول الحالية',
        total_selling_price: 'إجمالي سعر البيع',
        table: {
            date: 'التاريخ',
            sales: 'المبيعات',
            purchases: 'المشتريات',
            profit: 'الربح',
            expenses: 'المصروفات'
        },
        no_data: 'لا توجد بيانات متاحة.'
    },
    stock_report: {
        title: 'تقرير المخزون',
        view: 'عرض تقرير المخزون',
        no_report: 'لا توجد سجلات مخزون للتاريخ أو الموظف المحدد.',
        allStaffPlaceHolder: 'جميع الموظفين',
        column: {
            total_product: 'أنواع المنتجات الحالية',
            total_product_quantity: 'إجمالي المنتجات الحالية'
        }
    },
    subscription: {
        paywall_small: {
            title: 'ميزة VIP',
            description: 'انتهت فترة التجربة لهذه الميزة. ادعم تطوير هذا التطبيق المحلي من خلال الاشتراك.',
            button: 'عرض خطط الاشتراك'
        }
    },
    payment: {
        order: {
            title: 'الدفع'
        }
    },
    imageUploadMessage: {
        uploadSize: 'يجب ألا يتجاوز حجم الصورة 5 ميغابايت!',
        failedMessage: 'فشل في تحميل صورة العنصر، يرجى المحاولة مرة أخرى!',
        successUpload: 'تم تحميل الصورة بنجاح!',
        failedUIError: 'فشل في حذف الصورة، يرجى المحاولة مرة أخرى!',
        SuccessErrorImage: 'تم حذف الصورة بنجاح!'
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: 'اسم المنتج',
        categoryLabel: 'الفئة',
        BuyingPriceLabel: 'سعر الشراء',
        SellingLabel: 'سعر البيع',
        StockLabel: 'المخزون'
    },
    historyColumns: {
        Transactionlabel: 'نوع المعاملة',
        Locallabel: 'التوقيت المحلي',
        Createdlabel: 'تم الإنشاء بواسطة',
        Vendorlabel: 'اسم المورد',
        Buyerlabel: 'اسم المشتري',
        SKUlabel: 'SKU',
        Productlabel: 'اسم المنتج',
        Categorylabel: 'الفئة',
        Buyinglabel: 'سعر الشراء',
        Sellinglabel: 'سعر البيع',
        Initiallabel: 'المخزون الابتدائي',
        Finallabel: 'المخزون النهائي',
        Stocklabel: 'تغيير المخزون'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: 'اسم المنتج',
        categoryLabel: 'الفئة',
        buyingPriceLabel: 'سعر الشراء',
        sellingPriceLabel: 'سعر البيع',
        stockInLabel: 'المخزون الداخل',
        stockOutLabel: 'المخزون الخارج',
        remainingStockLabel: 'المخزون المتبقي',
        openStockLabel: 'المخزون الافتتاحي',
        weightedAverageCost: 'متوسط التكلفة المرجح',
        weightedAverageCostLabel: 'متوسط التكلفة المرجح',
        weightedAverageValueLabel: 'القيمة المتوسطة المرجحة'
    },
    accountingReportColumns: {
        dateRange: 'نطاق التاريخ',
        reportingPeriod: 'فترة التقرير',
        reportGenerate: 'إنشاء التقرير',
        warehouse: 'مستودع',
        labelDate: 'التاريخ',
        labelSales: 'المبيعات',
        labelPurchases: 'المشتريات',
        labelProfit: 'الربح',
        labelExpenses: 'المصروفات',
        reportOptions: 'خيارات التقرير',
        summaryCards: 'بطاقات ملخص KPI',
        grandTotal: 'المجموع الكلي',
        continued: 'تابع',
        subtotal: 'المجموع الفرعي',
        page: 'صفحة'
    },
    customerReportColumns: {
        labelName: 'الاسم',
        labelTotalTransaction: 'إجمالي المعاملات',
        labelTotalSales: 'إجمالي المبيعات',
        labelTotalProfit: 'إجمالي الربح'
    },
    scannerDialog: {
        finished: 'انتهى',
        reduce: 'تقليل',
        successfull: 'ناجح',
        searching: 'جارٍ البحث...',
        title: 'المسح نشط. وجهه نحو الرمز الشريطي!'
    },
    historyFilter: {
        SelectBuyer: 'اختر المشتري',
        SelectVendor: 'اختر المورد'
    },
    productStockFilter: {
        StockLowtoHigh: 'الحد الأدنى إلى الحد الأقصى',
        StockHightoLow: 'الحد الأقصى إلى الحد الأدنى',
        AlphabetAZ: 'الحروف من أ إلى ي',
        AlphabetZA: 'الحروف من ي إلى أ'
    },
    minimizeTitle: 'المسح نشط',
    security_guarantee: {
        title: 'ضمان أمان البيانات'
    },
    invoice: {
        invoicePlaceholder: 'رقم الفاتورة',
        invoiceTitle: 'فاتورة',
        manageInvoiceAddress: 'إدارة عنوان الفاتورة',
        selectOrManageAddresses: 'اختر أو أدر عناوين الفاتورة المخصصة أو أنشئها',
        useBusinessProfileAddress: 'استخدام عنوان ملف الأعمال',
        noCustomAddressesFound: 'لم يتم إضافة عناوين مخصصة',
        createCustomAddressDesc: 'أضف عناوين فوترة أو فروع مخصصة لطباعتها على فواتيرك بدلاً من بيانات الملف التجاري الافتراضية.',
        defaultFromBusinessProfile: 'الافتراضي من ملف الأعمال',
        editInvoiceAddress: 'تعديل عنوان الفاتورة',
        createNewInvoiceAddress: 'إنشاء عنوان فاتورة جديد',
        logoHeaderImage: 'الشعار / صورة الرأس',
        deleteInvoiceAddress: 'حذف عنوان الفاتورة؟',
        deleteAddressConfirmText: 'هل أنت متأكد أنك تريد حذف عنوان الفاتورة هذا؟ لا يمكن التراجع عن هذا الإجراء.'
    },
    ManageInvoiceAddress: 'إدارة عنوان الفاتورة',
    SelectOrManageAddresses: 'اختر أو أدر عناوين الفاتورة المخصصة أو أنشئها',
    UseBusinessProfileAddress: 'استخدام عنوان ملف الأعمال',
    CreateNewAddress: 'إنشاء عنوان جديد',
    UpdatingList: 'جارٍ تحديث القائمة...',
    NoCustomAddressesFound: 'لم يتم إضافة عناوين مخصصة',
    CreateCustomAddressDesc: 'أضف عناوين فوترة أو فروع مخصصة لطباعتها على فواتيرك بدلاً من بيانات الملف التجاري الافتراضية.',
    DefaultFromBusinessProfile: 'الافتراضي من ملف الأعمال',
    EditInvoiceAddress: 'تعديل عنوان الفاتورة',
    CreateNewInvoiceAddress: 'إنشاء عنوان فاتورة جديد',
    LogoHeaderImage: 'الشعار / صورة الرأس',
    UploadingImage: 'جارٍ رفع الصورة...',
    UploadImage: 'رفع الصورة',
    BusinessName: 'اسم النشاط التجاري',
    AddressDetails: 'تفاصيل العنوان',
    PhoneNumber: 'رقم الهاتف',
    EmailAddress: 'عنوان البريد الإلكتروني',
    DeleteInvoiceAddress: 'حذف عنوان الفاتورة؟',
    DeleteAddressConfirmText: 'هل أنت متأكد أنك تريد حذف عنوان الفاتورة هذا؟ لا يمكن التراجع عن هذا الإجراء.',

    stocklowreport: {
        no_stocklowreport_one: 'لا توجد عناصر بإعدادات أمان المخزون.',
        no_stocklowreport_two: 'يرجى إضافة كمية أمان المخزون.',
        currentStock: 'المخزون الحالي',
        safetyStock: 'مخزون الأمان',
        pricing: 'التسعير',
        costPrice: 'سعر التكلفة',
        sellingPrice: 'سعر البيع',
        productInfo: 'معلومات المنتج',
        category: 'الفئة',
        description: 'الوصف',
        no_description: 'لم يتم إضافة وصف',
        variants: 'المتغيرات',
        unitsOnHand: 'وحدات متوفرة',
        minimumThreshold: 'الحد الأدنى',
        adjust: 'تعديل',
        all: 'الكل',
        lowStock: 'مخزون منخفض',
        variantsDetails: 'تفاصيل المتغيرات',
        qty: 'الكمية',
        addSafetyStock: 'إضافة مخزون الأمان',
        searchByNameSku: 'البحث بالاسم / رمز SKU',
        safetyStockShort: 'أمان',
        warehouseSafetyStock: 'مخزون أمان المستودع'
    },
    low_alert_stock: 'أدخل كمية أمان المخزون',
    lowStockAlertNotify: 'ستتلقى إشعارًا عندما يكون المخزون أقل من الكمية المحددة.',
    applyButtonStockAlert: 'تطبيق',
    cancelButtonStockAlert: 'إلغاء',
    searchProductLabel: 'ابحث عن منتج...',
    successfullyAddedSafetyStock: 'تم تحديث مخزون الأمان بنجاح',
    safety_Stock: 'المخزون الآمن',
    safety_stock_placeholder: 'أدخل المخزون الآمن',
    lowStockDetailsInfo: {
        ProductCode: 'رمز المنتج',
        SafetyStock: 'مخزون الأمان',
        Stock: 'المخزون',
        CostPrice: 'سعر التكلفة',
        SellingPrice: 'سعر البيع',
        Category: 'الفئة',
        Description: 'الوصف',
        ExpirationDate: 'تاريخ انتهاء الصلاحية'
    },
    CustomLang: {
        Attribute: 'خاصية',
        AddAttribute: 'إضافة خاصية',
        EditAttribute: 'تعديل الخاصية',
        CustomLabePlaceholder: 'أدخل اسم الخاصية',
        CustomLabePlaceholderSelect: 'اختيار النوع',
        AddMoreAttribute: 'إضافة المزيد من الخصائص',
        ItemAttribute: 'خاصية العنصر',
        TableName: 'الاسم',
        TableType: 'النوع',
        TableAction: 'إجراء',
        TableDelete: 'حذف',
        TableEdit: 'تعديل',
        deleteMessage: 'تم حذف الخاصية بنجاح',
        editSuccessMessage: 'تم تحديث الخاصية بنجاح',
        AddSuccessMessage: 'تم إضافة الخاصية بنجاح',
        AddAtt: 'إضافة',
        EditAtt: 'تعديل',
        SubmitAtt: 'يتم الإرسال...'
    },
    Expenses: {
        ExpensesTitle: 'المصروفات',
        AddExpenses: 'إضافة المصروفات',
        ExpenseCategory: 'فئة المصروفات',
        NoExpenseCategory: 'لا توجد فئة مصاريف',
        AddExpenseCategory: 'إضافة فئة المصروفات',
        SelectExpenseCategory: 'اختر فئة المصروفات',
        NoExpenses: 'لا توجد مصروفات',
        ExpensesSuccess: 'تم إنشاء المصروفات بنجاح',
        ExpensesSuccessEdit: 'تم تحديث المصروفات بنجاح',
        ExpensesCategoryName: 'اسم فئة المصروفات',
        ExpensesSuccessDelete: 'تم حذف المصروفات بنجاح',
        TotalSpentThisWeek: 'إجمالي الإنفاق هذا الأسبوع',
        AddNEC: "إضافة فئة مصروف جديدة",
        NC: "فئة مصروف جديدة",
        EditNEC: "تعديل فئة المصروف"
    },
    Manufacturing: {
        ProducedProduct: "المنتج المصنع",
        QuantityManufactured: "الكمية المصنعة",
        UnitCost: "تكلفة الوحدة",
        RawMaterialsTotal: "إجمالي المواد الخام",
        TotalManufacturingCost: "إجمالي تكلفة التصنيع",
        NoRawMaterialsConsumed: "لم يتم استهلاك مواد خام.",
        CostBreakdown: "تفاصيل التكلفة",
        GeneratedBatch: "الدفعة المنتجة",
        StoredBinLocation: "موقع التخزين",
        NoManufacturingTransactionsFound: "لم يتم العثور على عمليات تصنيع",
        AddManufacture: 'إضافة تفاصيل التصنيع',
        Manufacturing: 'التصنيع',
        RawMaterials: 'المواد الخام',
        AdditonCosts: 'التكاليف الإضافية',
        RawMaterial: 'المادة الخام',
        AdditonCost: 'التكلفة الإضافية',
        TotalCost: 'التكلفة الإجمالية',
        AddRawMaterial: 'إضافة المواد الخام لـ',
        AddAdditonCost: 'إضافة التكلفة الإضافية لـ',
        AddMore: 'أضف المزيد',
        Add: 'إضافة',
        Update: 'تحديث',
        Updating: 'جارٍ الإرسال...',
        ProductRequired: 'المنتج مطلوب',
        QuantityRequired: 'الكمية مطلوبة',
        ChargeRequired: 'التكلفة مطلوبة',
        EstimatedCostRequired: 'التكلفة التقديرية مطلوبة',
        PurchasePriceRequired: 'سعر الشراء مطلوب',
        SelectCharge: 'اختر التكلفة',
        EstimatedCost: 'التكلفة التقديرية',
        SelectProduct: 'اختر منتجًا',
        Quantity: 'الكمية',
        ManufactureDetails: 'تفاصيل التصنيع',
        BuyingPrice: 'سعر الشراء',
        LabourCharge: 'تكلفة العمالة',
        ElectricityCost: 'تكلفة الكهرباء',
        PackagingCharge: 'تكلفة التعبئة',
        LogisticCost: 'تكلفة اللوجستيات',
        OtherCharges: 'تكاليف أخرى',
        Save: 'حفظ التفاصيل',
        PurchasePrice: 'سعر الشراء',
        Date: 'التاريخ',
        For: 'لـ',
        PurchaseRate: 'معدل الشراء (السعر)',
        Scrolltoloadmore: 'مرر لتحميل المزيد...',
        Noproductsfound: 'لم يتم العثور على منتجات',
        ManufacturingQuantity: 'كمية التصنيع',
        ManufactureAddedSuccess: 'تم تحديث تفاصيل التصنيع بنجاح'
    },
    Warehouses: {
        title: 'المستودع',
        transferOrder: 'نقل العناصر',
        AddTransferOrder: 'إضافة عناصر النقل',
        NewWarehouse: 'مستودع جديد',
        newHead: 'ابدأ في إدارة مستودعات متعددة!',
        headTwo: 'تتبع وأدر مخزونك بسلاسة عبر مستودعات متعددة',
        EnableWarehouse: 'تفعيل المستودع',
        EnableWarehouse2: 'تفعيل المستودع',
        OrganizationPrimary: 'المستودع الرئيسي للمؤسسة',
        Edit: 'تعديل',
        AreEnableWarehouse: 'هل أنت متأكد أنك تريد تفعيل المستودع؟',
        Confirm: 'تأكيد',
        Cancel: 'إلغاء',
        WarehouseCreatedSuccessfully: 'تم إنشاء المستودع بنجاح',
        MarkAsOP: 'تحديد كمستودع رئيسي للمؤسسة',
        MarkAsInAct: 'تحديد كغير نشط',
        MarkAsAct: 'تحديد كنشط',
        MarkedAsInactive: 'تم تحديد المستودع كغير نشط بنجاح',
        MarkedAsActive: 'تم تحديد المستودع كنشط بنجاح',
        MarkedAsOP: 'تم تحديد المستودع كرئيسي للمؤسسة بنجاح',
        WareDeletedSuccess: 'تم حذف المستودع بنجاح',
        SuccessfullyUpdatedWarehouse: 'تم تحديث المستودع بنجاح',
        SuccessfullyCreatedWarehouse: 'تم إنشاء المستودع بنجاح',
        EditWarehouse: 'تعديل المستودع',
        AddWarehouse: 'إضافة مستودع',
        WarehouseNameIsRequired: 'اسم المستودع مطلوب',
        EnterWarehouseName: 'أدخل اسم المستودع',
        EnterEmail: 'أدخل البريد الإلكتروني',
        EnterPhoneNumber: 'أدخل رقم الهاتف',
        Location: 'الموقع...',
        name: 'اسم المستودع',
        email: 'البريد الإلكتروني',
        phoneNumber: 'رقم الهاتف',
        location: 'الموقع',
        ViewProducts: ' عرض المنتجات',
        PageTitle: 'المستودع',
        noWarehouse: 'لا توجد مستودعات تطابق بحثك'
    },
    Assets: {
        headerTitle: 'الأصول',
        addAssetMessage: 'أضف الأصول هنا. لتخصيص أصل لموظف، انتقل إلى ملف الموظف الشخصي.',
        addAsset: 'إضافة أصل',
        editAsset: 'تعديل الأصل',
        assetCode: 'رمز الأصل',
        assetName: 'اسم الأصل',
        assetCategory: 'فئة الأصل',
        assetType: 'نوع الأصل',
        serialNumber: 'الرقم التسلسلي',
        location: 'الموقع',
        condition: 'الحالة',
        selectCondition: 'اختر الحالة',
        fair: 'متوسط',
        good: 'جيد',
        excellent: 'ممتاز',
        poor: 'سيء',
        notes: 'ملاحظات',
        submit: 'إرسال',
        submitting: 'جارٍ الإرسال',
        noCategory: 'لا توجد فئة',
        selectCategory: 'اختر الفئة',
        addAssetCat: 'إضافة فئة أصل',
        addAssetCatName: 'اسم فئة الأصل',
        edit: 'تعديل',
        status: 'الحالة',
        createdAt: 'تاريخ الإنشاء',
        viewAsset: 'عرض الأصل',
        assignAsset: 'تخصيص الأصل',
        conditionRet: 'الحالة (عند الإرجاع)',
        searchSelectAssets: 'البحث/اختيار الأصل',
        assetAssigned: 'تم تخصيص الأصل بنجاح',
        assetReturned: 'تم إرجاع الأصل بنجاح',
        selectAnAsset: 'يرجى اختيار أصل',
        action: 'إجراء',
        noAssetAssigned: 'لا توجد أصول مخصصة',
        reAssigned: 'إعادة التخصيص',
        assignedAssetsList: 'قائمة الأصول المخصصة',
        viewHistory: "عرض السجل",
        history: 'سجل الأصول',
        loadingHistory: "جارٍ تحميل السجل...",
        loadingMore: "جارٍ تحميل المزيد...",
        dateTime: "التاريخ والوقت",
        staff: "الموظف",
        AssignedBy: "تم التعيين بواسطة",
        assign: "تعيين",
        return: "إرجاع",
        unknown: "غير معروف",
        noHistory: "لا يوجد سجل متاح لهذا الأصل.",
        enterReturnNote: "أدخل ملاحظة للإرجاع",
        returnNote: "ملاحظة الإرجاع",
        enterAssignNote: "أدخل ملاحظة للتعيين",
        assignNote: "ملاحظة التعيين",
        AddNAC: "إضافة فئة أصول جديدة",
        EditNAC: "تعديل فئة الأصول",
        others: "أخرى"
    },
    LedgerTransaction: {
        ledgerDetails: 'تفاصيل دفتر الأستاذ',
        productName: 'اسم المنتج',
        totalQty: 'الكمية الإجمالية',
        date: 'التاريخ',
        receivedAmt: 'المبلغ المستلم',
        paid: 'مدفوع',
        discount: 'الخصم',
        balance: 'الرصيد',
        more: 'المزيد',
        total: 'الإجمالي',
        ledgerupdatedsuccessfully: 'تم تحديث دفتر الأستاذ بنجاح',
        ledgeraddedsuccessfully: 'تم إضافة دفتر الأستاذ بنجاح',
        viewLedger: 'عرض دفتر الأستاذ',
        edit: 'تعديل',
        create: 'إنشاء',
        Recieved: 'مستلم [إدخال المخزون]',
        payMode: 'طريقة الدفع',
        Refno: 'رقم المرجع'
    },
    ExtraField: {
        attachment: "مرفق",
        acceptOnlyImg: "يقبل الصور فقط.",
        addAttribute: "إضافة سمة",
        acceptImgAndDoc: "يقبل الصور والمستندات."
    },
    phoneInvoiceDownload: {
        Variant: "النوع",
        Warehouse: "المستودع",
        Bin: "الخانة",
        Batch: "الدفعة",
        Attributes: "الخصائص"
    },
    FewLocal: {
        SelectBin: "اختر الخانة",
        Live: "مباشر",
        Monitorinventorystocklevels: "مراقبة المخزون والحركة ومستويات المخزون",
        StockControlCentre: "مركز التحكم في المخزون",
        Nochartdataavailable: "لا توجد بيانات للرسم البياني",
        Disabled: "معطل",
        Enabled: "مفعل"
    },
    ImportExcel: {
        ImportStockfromExcel: "استيراد المخزون من Excel",
        ImportSafetyStockFromExcel: "استيراد مخزون الأمان من Excel",
        DragDrop: "اسحب وأسقط ملف Excel المعبأ هنا، أو انقر للتصفح",
        DT: "تحميل النموذج",
        GB: "رجوع",
        Downloading: "جاري التحميل...",
        ChangeFile: "تغيير الملف",
        ReadingExcelfile: "قراءة ملف Excel...",
        Processing: "جاري المعالجة...",
        submitUpdateStock: "إرسال وتحديث المخزون",
        submitUpdateSafetyStock: "تحديث مخزون الأمان",
        downloadLatestTemplate: "تحميل أحدث نموذج",
        productsFound: "تم العثور على منتجات",
        editSafetyStockBelow: "قم بتعديل قيم مخزون الأمان أدناه",
        loginRequired: "تسجيل الدخول مطلوب"
    },
    stockForm: {
        recordPaymentNow: "تسجيل الدفعة الآن",
        recordPaymentDescCustomer: "أدخل المبلغ الذي دفعه العميل",
        recordPaymentDescSupplier: "أدخل المبلغ الذي دفعه المورد",
        managePayments: "إدارة المدفوعات",
        invoice: "فاتورة",
        challan: "إيصال",
        recordPayment: "تسجيل الدفع",
        payableAmount: "المبلغ المستحق",
        paidAmount: "المبلغ المدفوع",
        paymentMethod: "طريقة الدفع",
        paymentDate: "تاريخ الدفع",
        reference: "مرجع",
        billId: "رقم الفاتورة",
        importExcel: "استيراد من إكسل",
        noThanks: "لا، شكرًا",
        checkHistory: "تحقق من السجل",
        wantViewHistory: "هل تريد عرض السجل؟",
        enterPayable: "أدخل المبلغ المستحق",
        enterPaid: "أدخل المبلغ المدفوع",
        selectPayment: "اختر طريقة الدفع",
        attachment: "مرفق",
        note: "ملاحظة"
    },
    HistoryEdit: {
        products: "المنتجات",
        add_product: "إضافة منتج",
        paidAmountInvalidMessage: "لا يمكن أن يكون المبلغ المدفوع أكبر من المبلغ المستحق",
        removingText: "إزالة هذا المنتج ستعكس تغييرات المخزون التي تمت أثناء هذه المعاملة.",
        remove: "إزالة"
    },
    ExcelProduct: {
        uploadFile: "رفع ملف",
        dragDrop: "اسحب وأسقط ملف إكسل أو انقر للرفع.",
        parsingFile: "جارٍ تحليل الملف",
        fileSelected: "تم اختيار الملف",
        reviewImportedData: "راجع البيانات المستوردة أدناه. تتم مطابقة الأعمدة تلقائيًا حيثما أمكن.",
        changeFile: "تغيير الملف",
        back: "رجوع",
        invalidFileType: "يرجى رفع ملف إكسل صالح (.xlsx أو .xls)",
        parseExcelError: "خطأ في تحليل ملف إكسل:",
        noData: "لا يحتوي ملف إكسل المرفوع على بيانات.",
        failedToRead: "فشل في قراءة ملف إكسل. يرجى المحاولة مرة أخرى.",
        Nodata: "لا توجد بيانات",
        unableToRead: "غير قادر على قراءة الملف.",
        buyingMustNumber: "يجب أن يكون سعر الشراء رقمًا",
        sellingMustNumber: "يجب أن يكون سعر البيع رقمًا",
        mustBeNumber: "يجب أن يكون رقمًا",
        bulkUploadfailed: "فشل الرفع الجماعي",
        importFromExcel: "استيراد من إكسل",
        generating: "جارٍ الإنشاء...",
        downloadTemplate: "تنزيل القالب",
        uploading: "جارٍ الرفع...",
        done: "تم",
        requiredField: "{field} مطلوب",
        bulkUpload: "رفع جماعي",
        duplicateSku: "تم العثور على رمز SKU مكرر",
        uploadedSuccessfully: "تم رفع جميع المنتجات بنجاح!",
        uploadCompleteIssues: "اكتمل الرفع مع وجود مشاكل",
        uploaded_products: "تم رفع {count} منتج(ات).",
        failed_products: "فشل {count}.",
        failed_items: "العناصر الفاشلة:"
    },
    Discount: {
        overallDiscount: "الخصم الإجمالي",
        final: "الإجمالي النهائي",
        balanceDue: "الرصيد المستحق",
        tax: "الضريبة"
    },
    ProductForm: {
        barcodeQuantity: "أدخل كمية الباركود",
        baseUnit: "الوحدة الأساسية (الرئيسية)",
        addSecondaryUnit: "إضافة وحدة ثانوية؟",
        selectUnit: "اختر الوحدة",
        subUnitDetails: "تفاصيل الوحدة الفرعية",
        subUnit: "الوحدة الفرعية",
        selectSubUnit: "اختر الوحدة الفرعية",
        conversionRate: "معدل التحويل",
        exampleLogic: "منطق المثال:",
        example: "إذا كنت تبيع الأقلام في علب، فقم بتعيين الوحدة الأساسية كعلبة وأضف وحدة فرعية (قطعة) بمعدل تحويل 50. هذا يعني أن العلبة الواحدة تحتوي على 50 قطعة.",
        basePrice: "السعر الأساسي"
    },
    barcode: {
        settings: 'إعدادات الباركود',
        labelSize: 'حجم الملصق',
        customSize: 'حجم مخصص...',
        widthMm: 'العرض (مم)',
        heightMm: 'الارتفاع (مم)',
        showPrice: 'إظهار سعر البيع على الملصق',
        noPrices: 'لم يتم تكوين أسعار بيع لهذا المنتج.',
        preview: 'معاينة',
        generate: 'إنشاء',
        label: 'ملصق',
        singlePage: 'صفحة واحدة',
        downloadOptions: 'خيارات التنزيل',
        chooseLayout: 'اختر تخطيط الباركود',
        allInSinglePage: 'إضافة جميع الباركود في صفحة واحدة.',
        allInA4Grid: 'الكل في صفحة واحدة',
        allInA4GridSub: 'يرتب جميع الباركود في شبكة A4',
        onePerPage: 'واحد لكل صفحة',
        onePerPageSub: 'كل باركود في صفحة ملصق خاصة به'
    },

    TransferItem: {
        transferItem: "نقل العناصر",
        Date: "التاريخ",
        Reason: "السبب",
        enterReason: "أدخل السبب",
        Name: "الاسم",
        QuantityTransfered: "الكمية المنقولة",
        SWarehouse: "المستودع المصدر",
        SelectSWarehouse: "اختر المستودع المصدر",
        DWarehouse: "المستودع الوجهة",
        SelectDWarehouse: "اختر المستودع الوجهة",
        CreatedBy: "تم الإنشاء بواسطة",
        CreatedTime: "وقت الإنشاء",
        UpdatedTime: "وقت التحديث",
        NoOrderFound: "لم يتم العثور على طلبات",
        New: "جديد",
        WarehouseItemTransfer: "نقل عناصر المستودع",
        TotalTransfers: "إجمالي التحويلات",
        EnterReason: "أدخل السبب",
        ItemDetails: "تفاصيل العنصر",
        CurrentAvailable: "المتوفر حالياً",
        TransferQty: "كمية النقل",
        SStock: "مخزون المصدر",
        DStock: "مخزون الوجهة",
        addDescription: "أضف وصفاً لعنصرك",
        selectVariant: "اختر متغيراً",
        addNewRow: "إضافة صف جديد",
        typeOrSelectItem: "اكتب للبحث",
        scrollToLoadMore: "مرر للتحميل المزيد",
        noProductsFound: "لم يتم العثور على منتجات",
        selectWarehouse: "اختر مستودعاً"
    },
    Sku: {
        searchSelectProduct: "بحث / اختيار منتج",
        searchSelectSku: "بحث / اختيار SKU",
        noSkuFound: "لم يتم العثور على SKU"
    },
    HistoryPage: {
        addFilter: "إضافة فلتر",
        filtersActive: "جميع الفلاتر نشطة",
        noProducts: "لا توجد منتجات",
        download: "تنزيل",
        recentlyUpdated: "تم التحديث مؤخراً",
    },
    StockPage: {
        challanNumber: "رقم الإيصال",
        subTotal: "المجموع الفرعي",
        totalTaxes: "الإجمالي والضرائب",
        taxInclusive: "شامل الضريبة",
        discountedValue: "القيمة بعد الخصم",
        taxValue: "قيمة الضريبة",
        totalAmount: "المبلغ الإجمالي",
        close: "إغلاق",
        addTax: "إضافة ضريبة",
        label: "التسمية",
        enterLabel: "أدخل التسمية",
        taxRate: "معدل الضريبة",
        enterTaxRate: "أدخل معدل الضريبة",
        selectTaxRate: "اختر معدل الضريبة",
        addNewTax: "إضافة معدل ضريبة جديد",
        discountProducts: "القيمة بعد الخصم (المنتجات)",
        taxProducts: "قيمة الضريبة (المنتجات)",
        clickAddPayment: "انقر لإضافة دفعة",
        paidGreaterPayable: "لا يمكن أن يكون المبلغ المدفوع أكبر من المبلغ المستحق",
        vendorCompulsory: "المورّد مطلوب لتسجيل الدفع",
        customerCompulsory: "يلزم تحديد العميل لتسجيل الدفع",
        updateInvoiceFormat: "تحديث تنسيق الفاتورة",
        updateChallanFormat: "تحديث تنسيق الإيصال",
        addPrefix: "إضافة بادئة",
        prefix: "بادئة"
    },
    EditHistoryPage: {
        search_by_notes: "البحث بالملاحظات",
        alertMessage: "تم تسجيل هذا التغيير في السجل فقط ولا يؤثر على مخزون المنتج الحالي.",
        paymentDetails: "تفاصيل الدفع",
        units: "الوحدات",
        customLabels: "تسميات مخصصة",
        value: "القيمة",
        Order_Info: "معلومات الطلب",
        percentage: "النسبة المئوية",
        Stock_updates_on_submit: "تحديث المخزون عند الإرسال",
        Summary: "الملخص"
    },
    historyCard: {
        paid: "مدفوع",
        partiallyPaid: "مدفوع جزئياً",
        billDate: "تاريخ الفاتورة",
        productDetails: "تفاصيل المنتج",
        paymentsHistory: "سجل المدفوعات",
        updatePayment: "تحديث الدفع",
        discounts: "الخصومات",
        inclusive: "(شامل)",
        discountOverall: "القيمة بعد الخصم (إجمالي)",
        dueAmount: "المبلغ المستحق",
        enterPaid: "أدخل المبلغ المدفوع",
        enterReference: "أدخل المرجع",
        enterNote: "أدخل ملاحظة",
        enterInvoice: "أدخل الفاتورة",
        enterChallan: "أدخل الإيصال",
        edit: "تم التعديل"
    },
    printInvoice: {
        billTo: "فاتورة إلى",
        ref: "رقم المرجع",
        mode: "طريقة الدفع",
        date: "التاريخ",
        amount: "المبلغ",
        totalPaid: "إجمالي المدفوع"
    },
    Contact: {
        supplier_required: "المورّد مطلوب لإدخال المخزون",
        customer_required: "العميل مطلوب لإخراج المخزون",
        key: "مفتاح",
        editHistory: "تعديل السجل",
        loading: "جارٍ التحميل..."
    },
    AW: {
        availablewarehouse: "المستودع المتاح",
        visibilityManagement: 'إدارة الرؤية',
        availablewarehouses: "المستودعات المتاحة",
        Active: "نشط",
        LWarehouse: "جاري تحميل المستودعات...",
        NWForthisProduct: "لم يتم العثور على مستودعات لهذا المنتج.",
        of: "من",
        WarehouseAvailabilty: "توافر المستودع",
    },
    Currency: {
        searchCurrency: "البحث عن العملات...",
        addCurrency: "إضافة عملة",
        addNewCurrency: "إضافة عملة جديدة",
        editCurrency: "تعديل العملة",
        currencySymbol: "رمز العملة",
        currencyName: "اسم العملة",
        enterCurrencySymbol: "أدخل رمز العملة",
        enterCurrencyName: "أدخل اسم العملة"
    },
    NewReportLang: {
        DM: "الحركة اليومية",
        WR: "تقرير المستودع",
        PDM: "حركة المنتج اليومية",
        TBP: "إجمالي سعر الشراء",
        TPQ: "إجمالي كمية المنتج",
        TP: "إجمالي المنتجات",
        CS: "المخزون الحالي",
        IV: "قيمة المخزون",
        DA: "المتوسط اليومي",
        TSI: "إجمالي المخزون الوارد",
        TSO: "إجمالي المخزون الصادر",
        TOR: "معدل الدوران",
        Tv: "القيمة الإجمالية",
        AST: "تتبع وحدات SKU النشطة",
        UT: "الوحدات المتتبعة",
        SL: "مستوى المخزون",
        Value: "القيمة",
        IO: "الوارد/الصادر",
        T: "الدوران",
        unitsD: "وحدات/يوم",
        Sort: "فرز",
        Sort_by: "فرز حسب",
        Units_available: "الوحدات المتاحة",
        Units_unavailable: "الوحدات غير المتاحة",
        Current_assets: "الأصول المتداولة",
        Search: "بحث",
        available: "متاح",
        assigned: "معين / مخصص",
        AYSWD: "هل أنت متأكد من أنك تريد الحذف؟",
        PTS: "تم نقل المستودع بنجاح",
        AUS: "تم تحديث الأصول بنجاح",
        ACS: "تم إنشاء الأصول بنجاح",
        VSP: "عرض سعر البيع",
        HUS: "تم تحديث السجل بنجاح",
    },
    ReplacementReturn: {
        selectProduct: "يرجى اختيار منتج",
        selectReplacementProduct: "يرجى اختيار منتج بديل واحد على الأقل",
        validQuantity: "يرجى إدخال كمية إرجاع صالحة",
        replacedSuccessfully: "تم استبدال المنتج بنجاح",
        returnSuccessfully: "تم إرجاع المنتج بنجاح",
        failedProcess: "فشل في المعالجة. يرجى المحاولة مرة أخرى.",
        return: "إرجاع",
        replace: "استبدال",
        typeSelectProduct: "اكتب أو اختر المنتج...",
        returnQuantity: "كمية الإرجاع",
        enterQuantity: "أدخل الكمية",
        replacementDate: "تاريخ الاستبدال",
        returnDate: "تاريخ الإرجاع",
        chooseCustomer: "اختر العميل",
        additionalNotes: "أضف أي ملاحظات إضافية...",
        replacementProducts: "منتجات الاستبدال",
        addProducts: "إضافة المزيد من المنتجات",
        tapSelect: "اضغط للاختيار من المنتجات المتاحة",
        currently: "حالياً",
        item: "عنصر",
        items: "عناصر",
        selected: "محدد",
        selectedItems: "العناصر المحددة",
        hideDetails: "إخفاء التفاصيل الإضافية",
        showDetails: "إظهار المزيد من التفاصيل",
        product: "منتج",
        priceLevel: "اختر مستوى السعر",
        customPrice: "أدخل سعر مخصص",
        noReplaceHistory: "لم يتم العثور على سجل استبدال",
        replaceReturn: "استبدال وإرجاع",
        replaceReturnHistory: "سجل الاستبدال والإرجاع"
    },
    OtherComponent: {
        mfgHistoryTitle: "تاريخ التصنيع",
        mfgHistoryDesc: "تتبع منتجات المخزون المصنعة",
        dailyOperation: "العمليات اليومية",
        freqUsed: "الإجراءات المستخدمة بشكل متكرر لتحديث السجلات بسرعة",
        manageCategory: "إدارة الفئات",
        organizeCaterory: "تنظيم وإدارة فئات المنتجات والمصروفات والأصول",
        businessRecord: "سجلات الأعمال",
        organizeRecord: "تنظيم وإدارة سجلات أعمالك",
        trackHistory: "تتبع التاريخ",
        completeTracking: "سجل كامل للتدقيق والتتبع",
        Verifyinventorycount: "التحقق من تعداد المخزون",
        Exchangerates: "أسعار الصرف",
        Productiontracking: "تتبع الإنتاج",
        Fixedassetregister: "سجل الأصول الثابتة",
        Storagelocations: "مواقع التخزين",
        warehouseAvailability: 'توافر المنتج على مستوى المستودع',
        Logreviewspend: "تسجيل ومراجعة الإنفاق",
        Productgroupings: "تجميع المنتجات",
        Classifyexpenditures: "تصنيف المصروفات",
        Assetclassification: "تصنيف الأصول",
        Manageexchanges: "إدارة الصرف",
        Returnauditlog: "سجل تدقيق المرتجعات",
        Interlocationmoves: "نقل بين المواقع",
        Manageoperationscategoriesrecordsandhistory: "إدارة العمليات والفئات والسجلات والتاريخ"
    },
    no_permission_dialog: {
        title: 'لا توجد صلاحية',
        historyDescription: "ليس لديك صلاحية لعرض سجل المعاملات. يرجى التواصل مع مسؤول النظام.",
        replacementHistoryDescription: "ليس لديك صلاحية لعرض سجل الاستبدال والإرجاع. يرجى التواصل مع مسؤول النظام.",
        transferHistoryDescription: "ليس لديك صلاحية لعرض سجل نقل المستودع. يرجى التواصل مع مسؤول النظام."
    },
    OthersHistory: {
        title: "إدارة السجل",
        transferHistory: "إدارة سجل النقل",
        transactionHistory: "إدارة سجل المعاملات",
        replacementHistory: "إدارة سجل الاستبدال والإرجاع"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "تصفح وشراء المنتجات التي يشاركها النشاط التجاري.",
        description: "تصفح المنتجات التي يشاركها النشاط التجاري.",
        productsAvailable: "المنتجات المتاحة",
        noImageAvailable: "لا توجد صورة متاحة",
        productDetails: "تفاصيل المنتج",
        inStock: "متوفر في المخزون",
        availableVariants: "الخيارات المتاحة",
        options: "خيارات",
        orders: "الطلبات",


        searchProducts: "ابحث عن منتجات...",
        noProductsFound: "لم يتم العثور على منتجات",
        tryDifferentKeyword: "جرب البحث بكلمة مختلفة",
        variants: "المتغيرات",
        stock: "المخزون",
        cart: "السلة",
        products: "المنتجات",
        viewCart: "عرض السلة",
        backToProducts: "العودة للمنتجات",
        yourCart: "سلتك",
        clear: "مسح",
        cartEmpty: "سلتك فارغة",
        cartEmptyDesc: "تصفح الكتالوج وأضف المنتجات التي ترغب في طلبها.",
        browseProducts: "تصفح المنتجات",
        selectedItems: "العناصر المختارة",
        itemInCart: "عنصر في السلة",
        itemsInCart: "عناصر في السلة",
        customerDeliveryDetails: "تفاصيل العميل والتوصيل",
        fullName: "الاسم الكامل",
        enterFullName: "أدخل اسمك الكامل",
        deliveryAddress: "عنوان التوصيل",
        addressPlaceholder: "عنوان الشارع، المبنى، المدينة، الرمز البريدي...",
        orderNote: "ملاحظة الطلب (اختياري)",
        orderNotePlaceholder: "تعليمات خاصة أو ملاحظات التوصيل...",
        paymentMode: "طريقة الدفع",
        subtotal: "المجموع الفرعي",
        items: "عناصر",
        totalAmount: "المبلغ الإجمالي",
        orderOnWhatsApp: "اطلب عبر WhatsApp 📲",
        orderPlaced: "تم تقديم الطلب بنجاح! 🎉",
        orderPlacedDesc: "تم تسجيل طلبك وتم فتح WhatsApp لإرسال تفاصيل الطلب.",
        continueShopping: "متابعة التسوق 🛍️",
        cartEmptyTitle: "السلة فارغة",
        cartEmptyToast: "يرجى إضافة منتجات إلى سلتك قبل الدفع.",
        incompleteTitle: "تفاصيل غير مكتملة",
        incompleteToast: "يرجى ملء جميع الحقول المطلوبة قبل تقديم الطلب.",
        nameRequired: "الاسم الكامل مطلوب",
        addressRequired: "عنوان التوصيل مطلوب",
        catalogUnavailable: "الكتالوج غير متاح حالياً",
        catalogUnavailableDesc: "هذا الكتالوج غير نشط حالياً. يرجى التواصل مع الشركة.",
        invalidCatalogLink: "رابط كتالوج غير صالح 🚫",
        invalidCatalogDesc: "هذه الصفحة تفتقد معلومات مطلوبة.",
        missing: "مفقود",
        catalogSlug: "رمز الكتالوج",
        goBackHome: "العودة للرئيسية",
        inventoryManagement: "إدارة المخزون والفواتير 🚀 Simply",
        enter: "أدخل",
        select: "اختر",
        // Catalog Order translations
        catalogOrders: 'طلبات الكتالوج',
        pending: 'قيد الانتظار',
        converted: 'تم التحويل',
        cancelled: 'ملغى',
        totalRevenue: 'القيمة الإجمالية',
        totalCatalogOrders: 'إجمالي الطلبات عبر الإنترنت',
        convertToSalesOrder: 'تحويل إلى أمر بيع',
        date: 'التاريخ',
        status: 'الحالة',
        action: 'الإجراء',
        searchOrders: 'ابحث باسم العميل أو الهاتف...',
        noMatchingOrders: 'لم يتم العثور على طلبات مطابقة',
        noStatusOrders: 'لم يتم العثور على طلبات {status}',
        tryDifferentSearch: 'حاول البحث باسم عميل أو رقم هاتف مختلف.',
        noOrdersWithStatus: 'لا توجد حاليًا طلبات بحالة {status}.',
        noOrdersYet: 'لا توجد طلبات كتالوج بعد',
        noOrdersDescription: 'ستظهر الطلبات المقدمة من كتالوجك عبر الإنترنت هنا.',
        guestCustomer: 'عميل زائر',
        item: 'عنصر',
        moreItems: '+{count} المزيد',
        viewDetails: 'عرض التفاصيل',
        viewSalesOrder: 'عرض أمر البيع',
        cancelOrder: 'إلغاء الطلب',
        confirmCancelTitle: 'إلغاء طلب الكتالوج؟',
        confirmCancelOrder: 'هل أنت متأكد أنك تريد إلغاء هذا الطلب؟ لا يمكن التراجع عن هذا الإجراء.',
        keepOrder: 'لا، احتفظ بالطلب',
        confirmCancelAction: 'نعم، ألغِ الطلب',
        orderNotFound: 'طلب الكتالوج غير موجود',
        orderNotFoundDescription: 'تعذر العثور على هذا الطلب أو قد لا يكون لديك إذن لعرضه.',
        backToCatalogOrders: 'العودة إلى طلبات الكتالوج',
        placedOn: 'تم الطلب في',
        totalItems: 'إجمالي العناصر',
        orderedProducts: 'المنتجات المطلوبة',
        itemDetails: 'تفاصيل العنصر',
        quantity: 'الكمية',
        unitPrice: 'سعر الوحدة',
        total: 'الإجمالي',
        variant: 'الخيار',
        customerInformation: 'معلومات العميل',
        additionalFields: 'حقول إضافية',
        fields: 'حقول',
    },
    stockNew: {
        Npay: "لم تتم إضافة منتجات بعد",
        emptydesc: "اختر منتجًا من كتالوجك وأدخل الكمية الواردة لتسجيل المخزون.",
        tipText: "نصيحة: يمكنك أيضًا رفع ملف إكسل",
        OT: "إجمالي الطلب",
        Collapse: "طي"
    },
    deleteBulk: {
        Bulkoperation: "عملية جماعية",
        Applyproducts: "تطبيق إجراءات على منتجات متعددة",
        Bulkupload: "رفع جماعي",
        ImportCSVfile: "استيراد المنتجات عبر ملف Excel أو CSV",
        or: "أو",
        Bulkdelete: "حذف جماعي",
        Permanentlyallproducts: "إزالة جميع المنتجات نهائيًا",
        IrrText: "الحذف الجماعي لا يمكن التراجع عنه. قم بتصدير نسخة احتياطية أولاً إذا لزم الأمر.",
        SeP: "المنتجات المحددة",
        sP: "حدد المنتج",
        DA: "حذف الكل",
        DP: "حذف المنتجات",
        sL: "تحديد الكل",
        ASDE: "هل أنت متأكد من حذف جميع المنتجات باستثناء",
        ASDAllP: "هل أنت متأكد من حذف جميع المنتجات؟",
        ASD: "هل أنت متأكد من حذف",
        products: "منتجات",
        TACBU: "لا يمكن التراجع عن هذا الإجراء.",
        LP: "جاري تحميل المنتجات...",
        FM: "جاري جلب المزيد...",
        NPF: "لم يتم العثور على منتجات.",
        LMP: "جاري تحميل المزيد من المنتجات..."
    },
    NewVariantModal: {
        Definevariantsassign: "تحديد المتغيرات وتعيين الكميات",
        Nothingallocated: "لا شيء مخصص",
        Overallocated: "مخصص زيادة عن الحد",
        Fullyallocated: "مخصص بالكامل",
        Overby: "زيادة بمقدار",
        Allvariantsneedaname: "جميع المتغيرات تحتاج إلى اسم.",
        Reducequantities: "قلل الكميات.",
        Overallocatedby: "مخصص زيادة بمقدار",
        Quantitiesmustmatchthetotalavailability: "يجب أن تتطابق الكميات مع التوافر الإجمالي.",
        Allocatequantitiesacrosswarehouses: "توزيع الكميات عبر المستودعات",
        Notfullydistributed: "غير موزع بالكامل:",
        remaining: "متبقي",
        Qty: "الكمية",
        Inactive: "غير نشط",
        left: "متبقي"
    },
    ProductFormNew: {
        BasicInfo: "المعلومات الأساسية",
        ProductImage: "صورة المنتج",
        Images: "الصور",
        Pricing: "التسعير",
        Everypriceneedsbothalabelandanamount: "كل سعر يحتاج إلى تسمية ومبلغ",
        AddalabellikeWholesaleorRetailtoidentifythisprice: "أضف تسمية مثل \"بالجملة\" أو \"بالتجزئة\" لتحديد هذا السعر",
        AddMultiplePrice: "إضافة أسعار متعددة",
        NoPhotosLetAiFind: "لا توجد صور؟ دع الذكاء الاصطناعي يجد صور المنتج",
        AddProductImagesTitle: "إضافة صور المنتج",
        ChooseHowToAddPhotos: "اختر كيفية إضافة صور لهذا المنتج:",
        SearchWithAi: "البحث باستخدام الذكاء الاصطناعي",
        SearchWithAiDesc: "البحث عن صور المنتج وتحديدها تلقائيًا باستخدام الذكاء الاصطناعي",
        FilesFileExplorer: "الملفات (مستكشف الملفات)",
        FilesFileExplorerDesc: "اختر الصور مباشرة من جهاز الكمبيوتر الخاص بك",
        AiProductImageFinder: "مكتشف صور المنتج بالذكاء الاصطناعي",
        AiProductImageFinderDesc: "ابحث عن الصور وحددها لمنتجك",
        TypeProductNamePlaceholder: "اكتب اسم المنتج...",
        SearchForYourProduct: "ابحث عن منتجك",
        SearchForYourProductHint: `جرب اسم العلامة التجارية أو المنتج`,
        ImagesSelected: "صور محددة",
        AddSelected: "إضافة المحدد"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "تعريف حقل مخصص جديد",
        AttributeName: "اسم السمة",
        DataType: "نوع البيانات",
        Noattributesfound: "لم يتم العثور على سمات",
        ManageAttributes: "إدارة السمات",
        Editordeleteexistingattributes: "تحرير أو حذف السمات الموجودة",
        UpdateAttribute: "تحديث السمة",
        Saving: "جاري الحفظ..."
    },
    NewExpenses: {
        Noexpensesyet: "لا توجد مصروفات بعد",
        Addyourfirstexpensetostarttrackingyourspending: "أضف أول مصروف لك لبدء تتبع إنفاقك.",
        TOTALEXPENSES: "إجمالي المصروفات",
        ENTRIES: "الإدخالات",
        BYCATEGORY: "حسب الفئة",
        Nocategoriestodisplay: "لا توجد فئات للعرض",
        DateanfTime: "التاريخ والوقت"
    },
    PurchaseSales: {
        CancelOrder: "إلغاء الطلب",
        ReopenOrder: "إعادة فتح الطلب",
        Reopen: "إعادة فتح",
        ConfirmCancelOrder: "هل أنت متأكد أنك تريد إلغاء هذا الطلب؟",
        ConfirmReopenOrder: "هل أنت متأكد أنك تريد إعادة فتح هذا الطلب؟",
        OrderCancelledSuccessfully: "تم إلغاء الطلب بنجاح.",
        OrderReopenedSuccessfully: "تم إعادة فتح الطلب بنجاح.",
        CancelledBy: "تم الإلغاء بواسطة",
        Cancelled: "ملغى",
        ConvertPriceBasedOnUnitConversion: "تحويل السعر بناءً على تحويل الوحدة",
        MarkPaymentAsPending: "تحديد الدفعة كمعلقة",
        PendingReceivableDesc: "تم تسجيل المبلغ كمستحق. سجّل الدفعة عند استلامها.",
        PendingPayableDesc: "تم تسجيل المبلغ كمستحق الدفع. سجّل الدفعة عند دفعها.",
        SelectCustomerFirst: "اختر العميل أولًا",
        SelectSupplierFirst: "اختر المورد أولًا",
        SelectItemsFirst: "يرجى تحديد عنصر واحد على الأقل أولاً",
        PaymentMarkedPendingDesc: "تم تحديد الدفعة كمعلقة. ألغِ تحديد 'تحديد الدفعة كمعلقة' لتسجيل الدفعة الآن.",
        SelectCustomerAndItemFirst: "يرجى اختيار العميل وعنصر واحد على الأقل أولاً",
        SelectSupplierAndItemFirst: "يرجى اختيار المورد وعنصر واحد على الأقل أولاً",
        SelectCustomerProductFirst: "اختر العميل والمنتج أولاً",
        SelectSupplierProductFirst: "اختر المورد والمنتج أولاً",
        Receivables: "المستحقات",
        Payables: "المدفوعات المستحقة",
        AccessDenied: "الوصول مرفوض",
        YouDonthaeP: "ليس لديك إذن لعرض هذه الصفحة. إذا كنت تعتقد أن هذا خطأ، يرجى الاتصال بمسؤول النظام.",
        purchase: "الشراء",
        sales: "المبيعات",
        Areyousureyouwantto: "هل أنت متأكد من أنك تريد",
        Thisactionwillupdateitsstatus: "سيقوم هذا الإجراء بتحديث حالته.",
        ReasonOPtional: "السبب (اختياري)",
        Enterareasonfor: "أدخل سببًا لـ",
        optionalDot: "(اختياري)...",
        Reject: "رفض",
        ConfirmOrder: "تأكيد الطلب",
        RejectOrder: "رفض الطلب",
        Previous: "السابق",
        First: "الأول",
        Order: "الطلب",
        Items: "العناصر",
        Memo: "مذكرة",
        SelectDateRange: "اختر نطاق التاريخ",
        List: "قائمة",
        Board: "لوحة",
        View: "عرض",
        CreateSalesOrder: "إنشاء أمر مبيعات",
        CreatePurchaseOrder: "إنشاء أمر شراء",
        successfully: "بنجاح",
        ManageAttachments: "إدارة المرفقات",
        Stockoutitemsimmediatelyaftersaving: "إخراج المخزون فور الحفظ.",
        Stockinitemsimmediatelyaftersavingthisorder: "إدخال المخزون فور حفظ هذا الطلب.",
        ViewAttachments: "عرض المرفقات",
        MemoAttachments: "مذكرة ومرفقات",
        ReceivedDate: "تاريخ الاستلام",
        ShippedDate: "تاريخ الشحن",
        OrderDate: "تاريخ الطلب",
        OrderDetails: "تفاصيل الطلب",
        Subtotal: "الإجمالي الفرعي",
        OrderSummary: "ملخص الطلب",
        AddItem: "إضافة عنصر",
        NewSalesOrder: "أمر مبيعات جديد",
        NewPurchaseOrder: "أمر شراء جديد",
        Createandmanageyour: "إنشاء وإدارة",
        orders: "طلباتك",
        Removeitem: "إزالة العنصر",
        UnitPrice: "سعر الوحدة",
        PurchaseOrder: "أمر شراء",
        SalesOrder: "أمر مبيعات",
        PurchaseInvoice: "فاتورة شراء",
        SalesInvoice: "فاتورة مبيعات",
        PurchaseOrdernotfound: "أمر الشراء غير موجود",
        Approve: "موافقة",
        MarkasShipped: "وضع علامة كمشحون",
        MarkasReceived: "وضع علامة كمستلم",
        Marking: "جاري التحديد...",
        PartiallyShip: "شحن جزئي",
        PartiallyReceive: "استلام جزئي",
        Deleting: "جاري الحذف...",
        Transaction: "المعاملة",
        Details: "التفاصيل",
        Item: "العنصر",
        Received: "مستلم",
        Shipped: "مشحون",
        Ordered: "مطلوب",
        units: "وحدات",
        Overalldiscount: "خصم عام",
        Transactions: "المعاملات",
        Notransactionsfound: "لم يتم العثور على معاملات",
        OrderedQty: "الكمية المطلوبة",
        Totalqty: "إجمالي الكمية",
        StockingOut: "جاري إخراج المخزون...",
        StockingIn: "جاري إدخال المخزون...",
        thiorderUpdateStuau: "هذا الطلب؟ سيحدث هذا الإجراء حالته.",
        TransactionDetails: "تفاصيل المعاملة",
        Fetchingtransactiondetails: "جاري جلب تفاصيل المعاملة...",
        Nodetailsfoundforthistransaction: "لم يتم العثور على تفاصيل لهذه المعاملة.",
        TotalBreakDown: "تفصيل الإجمالي",
        ChangeAmount: "مبلغ التغيير",
        Attachments: "المرفقات",
        PoNumber: "رقم أمر الشراء",
        SoNumber: "رقم أمر المبيعات",
        partner: "الشريك",
        EditPurchase: "تعديل الشراء",
        EditSales: "تعديل المبيعات",
        PurchaseOrderDetails: "تفاصيل أمر الشراء",
        SalesOrderDetails: "تفاصيل أمر المبيعات",
        OrderType: "نوع الطلب",
        SelectOrderType: "اختر نوع الطلب",
        OrderTypePrepaid: "مسبق الدفع",
        OrderTypeCOD: "الدفع عند الاستلام",
        OrderTypePayLater: "الدفع لاحقًا",
        OrderTypePartialPayment: "دفع جزئي",
        OrderTypeSubscription: "اشتراك",
        viewAvailabilty: 'عرض التوفر',
        NotReceived: "لم يتم الاستلام",
        NotShipped: "لم يتم الشحن",
        PartiallyReceived: "مستلم جزئيًا",
        PartiallyShipped: "مشحون جزئيًا",
    },
    PriceReference: {
        HighPrice: "سعر مرتفع",
        LowPrice: "سعر منخفض",
        LastPrice: "آخر سعر",
        LastPurchasePrice: "آخر سعر شراء",
        Nopricerecordsfound: "لم يتم العثور على سجلات أسعار",
        BuyingPriceReference: "مرجع سعر الشراء",
        SellingPriceReference: "مرجع سعر البيع",
        Viewstockinpricesfortheselectedvendorandproduct: "عرض أسعار الدخول للمورد والمنتج المحدد",
        Viewstockoutpricesfortheselectedcustomerandproduct: "عرض أسعار الخروج للعميل والمنتج المحدد"
    },
    SubscriptionLocale: {
        premiumPlan: "خطة بريميوم",
        heading: "اتخذ قرارات أعمال",
        headingHighlight: "بناءً على البيانات",
        subtitle: "افتح القوة الكاملة لتحليلات أعمالك — بدون قيود أو تنازلات.",
        choosePlan: "اختر خطتك",
        monthly: "شهريًا",
        annual: "سنويًا",
        oneTime: "مرة واحدة (الشهر)",
        perMonth: "لكل شهر",
        perYear: "لكل سنة",
        bestValue: "أفضل قيمة",
        continueWith: "تابع مع",
        perMonthShort: "شهر",
        perYearShort: "سنة",
        troubleWithSubscription: "تواجه مشكلة في الاشتراك؟",
        contactUs: "اتصل بنا",
        paymentNotReady: "الدفع غير جاهز",
        checkoutError: "خطأ في الدفع",
        pricePreviewError: "خطأ في معاينة السعر",
        // Popup
        subNotAvailable: "Subscription not available",
        subNotAvailableDesc: "Web subscriptions are currently not available in your country. Please subscribe through our mobile app or contact us directly for help.",

    },
    SubscriptionLocale2: {
        GoPro: "انتقل إلى Pro",
        Makesmarterdecisionsbackedbyrealbusinessdata: "اتخذ قرارات أذكى مدعومة ببيانات أعمال حقيقية",
        ExploreProPlans: "استكشف خطط Pro"
    },
    emptyWarehouseState: {
        tips: [
            "يمكنك امتلاك مستودعات متعددة لمواقع فيزيائية مختلفة",
            "يتتبع كل منتج المخزون في كل مستودع بشكل مستقل",
            'استخدم "نقل المستودع" لنقل المخزون بين المواقع'
        ],
        NoWarehousesConfigured: "لم يتم تكوين أي مستودعات",
        desc: "ابدأ بإضافة مستودعاتك (إذا كان لديك أكثر من واحد)، ثم انتقل إلى إضافة المنتجات وتسجيل حركات المخزون.",
        WarehouseSetupTips: "نصائح إعداد المستودع",
        Noproductselected: "لم يتم اختيار أي منتج",
        Selectaproductfromthelefttoviewlowstockdetails: "اختر منتجًا من اليسار لعرض تفاصيل المخزون المنخفض.",
        Chooseaproductfromthelist: "اختر منتجًا من القائمة",
        SelectProduct: "اختر المنتج",
        SetQuantity: "حدد الكمية",
        Showing: "عرض",
        products: "منتجات",
        Continue: "متابعة",
        SaveSafetyStock: "حفظ مخزون السلامة",
        SafetyStockSaved: "تم حفظ مخزون السلامة!",
        hasbeensetto: "تم تعيينه إلى",
        AddAnother: "إضافة آخر",
        Chooseaproduct: "اختر منتجًا",
        Step: "الخطوة",
        of: "من",
        Setsafetyquantity: "حدد كمية السلامة",
        Complete: "اكتمل",
        SafetyStockQuantity: "كمية مخزون السلامة",
        Minimumunitsdropsbelowthisnumber: "الحد الأدنى من الوحدات التي يجب الاحتفاظ بها في المخزون. يتم إطلاق تنبيه عندما ينخفض المخزون عن هذا الرقم.",
        NewSafetyStock: "مخزون سلامة جديد",
        SafetyNow: "السلامة الآن",
        SettingTo: "يتم التعيين إلى",
        Change: "تغيير",
        sell: "بيع",
        cost: "التكلفة",
        BulUD: "رفع/حذف جماعي"
    },
    SimplyLoginUI: {
        sslEncryption: "تشفير SSL بـ 256 بت",
        dataPrivate: "بياناتك خاصة 100%",
        worksOnDevices: "يعمل على Android و iPhone",
        realTimeSync: "مزامنة فورية عبر جميع الأجهزة",
        cloudBackup: "نسخ احتياطي تلقائي على السحابة",
        availableOn: "متوفر على الويب و Android و iOS",
        tagline: "مخزونك،",
        taglineEm: "ببساطة جميلة.",
        subtitle: "سجل الدخول لإدارة المخزون، تتبع المبيعات، وتحريك أعمالك — كل ذلك في مكان واحد.",
        feature1Title: "تتبع المخزون في الوقت الفعلي",
        feature1Desc: "اعرف بالضبط ما هو موجود في كل مستودع، محدث دائمًا.",
        feature2Title: "أوامر البيع والشراء",
        feature2Desc: "أنشئ الفواتير، أدر الموردين، وتابع كل معاملة.",
        feature3Title: "تقارير ذكية",
        feature3Desc: "تقارير المالية والمخزون والحركات اليومية في لمحة.",
        feature4Title: "مزامنة فورية عبر جميع الأجهزة",
        feature4Desc: "التغييرات على الهاتف تظهر فورًا على الويب — والعكس صحيح.",
        rating1: "تقييم",
        rating2: "4.9/5",
        rating3: "من 10,000 شركة تجارة جملة",
        brandName: "Simply",
        greeting: "مرحبا مرة أخرى! 👋",
        noPasswordNeeded: "سجل الدخول للوصول إلى مخزونك — Android و iPhone والويب، كلها متزامنة.",
        badge1: "إدارة المخزون",
        badge2: "تتبع المبيعات",
        badge3: "التقارير",
        trustEncryptedTitle: "مشفر",
        trustEncryptedSub: "256-bit SSL",
        trustPrivateTitle: "خاص",
        trustPrivateSub: "بياناتك فقط",
        trustBackedTitle: "مدعوم",
        trustBackedSub: "نسخ احتياطي يومي تلقائي",
        availableOnLabel: "متوفر على",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "الويب",
        syncBadge: "جميع الأجهزة تتزامن فورًا في الوقت الفعلي",
        securityNote: "100% آمن.",
        securityDesc: "تشفير على مستوى البنوك يحمي جميع بياناتك. نحن نقرأ فقط اسمك والبريد الإلكتروني — لا شيء آخر أبدًا.",
        signingIn: "جاري تسجيل دخولك…",
        termsPrefix: "بتسجيل الدخول أنت توافق على",
        privacyPolicy: "سياسة الخصوصية",
        and: "و",
        termsOfService: "شروط الخدمة",
        google: "تسجيل الدخول باستخدام Google"
    },
    BatchLocal: {
        BatchName: "اسم الدفعة",
        EnterBatchName: "أدخل اسم الدفعة",
        EnterNotes: "أدخل الملاحظات",
        ExpiredDate: "تاريخ انتهاء الصلاحية",
        Selectexpireddate: "اختر تاريخ انتهاء الصلاحية",
        BatchStatus: "حالة الدفعة",
        CreatedDate: "تاريخ الإنشاء",
        Areyousureyouwanttodeletethisbatch: "هل أنت متأكد أنك تريد حذف هذه الدفعة؟",
        Youhavencreatedanybatchforthisproduct: "لم تقم بإنشاء أي دفعة لهذا المنتج.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "أنشئ دفعةك الأولى لبدء تتبع المخزون حسب اللوت وتاريخ انتهاء الصلاحية.",
        Nobatchesyet: "لا توجد دفعات بعد",
        Whatisbatchmanagement: "ما هي إدارة الدفعات؟",
        Howithelpsyourbusiness: "كيف تساعد عملك",
        Trackbylotnumber: "تتبع حسب رقم اللوت",
        Trackbylotnumberdesc: "قم بتجميع المخزون حسب دفعة الشركة المصنعة حتى تعرف دائمًا من أي لوت جاءت الوحدة.",
        Expirydatecontrol: "التحكم في تاريخ انتهاء الصلاحية",
        Expirydatecontroldesc: "احصل على تنبيهات قبل انتهاء صلاحية المخزون. بِع الدفعات القديمة أولاً وقلل الهدر تلقائيًا.",
        Fulltraceability: "التتبع الكامل",
        Fulltraceabilitydesc: "شاهد بالضبط أي دفعة تم استخدامها في كل معاملة — مثالي للتدقيق والاستدعاء.",
        Supplierwisestock: "المخزون حسب المورد",
        Supplierwisestockdesc: "فصل المخزون من موردين مختلفين حتى لنفس المنتج. قارن الجودة دفعة بدفعة.",
        Createyourfirstbatchbutton: "أنشئ دفعةك الأولى",
        Nomatchesfound: "لم يتم العثور على تطابقات",
        NomatchesfounddescBefore: "لم نتمكن من العثور على أي دفعات مطابقة لـ ",
        NomatchesfounddescAfter: "",
        Clearsearch: "مسح البحث",
        Nohistoryfoundthisbatch: "لم يتم العثور على تاريخ لهذه الدفعة",
        ComprehensiveDetails: "تفاصيل شاملة",
        History: "التاريخ",
        InBatch: "في الدفعة",
        Noproductfoundinthisbatch: "لم يتم العثور على أي منتج في هذه الدفعة",
        SelectBatch: "اختر الدفعة",
        available: "متوفر",
        Searchbatches: "ابحث عن الدفعات...",
        Expires: "تنتهي صلاحيته",
        Nobatchesfound: "لم يتم العثور على دفعات",
        ManageBatches: "إدارة الدفعات",
        Batchmanagement: "إدارة الدفعات",
        Trackstockexpiry: "تتبع المخزون حسب الدفعة وتاريخ الانتهاء",
        Turnoffbatchmanagement: "إيقاف إدارة الدفعات؟",
        Yourgsafe: "بيانات الدفعات الموجودة لديك تبقى آمنة.",
        Reenableanytimefrom: "يمكنك إعادة التفعيل في أي وقت من",
        Otherstab: "علامة التبويب الأخرى",
        AddBatch: "إضافة دفعة",
        Total: "الإجمالي",
        AssignProduct: "تعيين المنتج",
        EditProductAssignment: "تعديل تعيين المنتج",
        AssignProducttoBatch: "تعيين المنتج إلى الدفعة",
        Updateproductconfiguration: "تحديث إعدادات المنتج",
        Step1of2: "الخطوة 1 من 2",
        Step2of2: "الخطوة 2 من 2",
        Selectvariantwarehouse: "اختر النوع والمستودع",
        SelectedProduct: "المنتج المختار",
        AssignQuantity: "تعيين الكمية",
        BatchInfo: "معلومات الدفعة",
        Wecouldnthisproductidentifier: "لم نتمكن من العثور على أي دفعات مرتبطة بهذا المعرف للمنتج.",
        NoActiveBatches: "لا توجد دفعات نشطة",
        Endofresults: "نهاية النتائج",
        Expiry: "انتهاء الصلاحية",
        BatchManagementDescription: "تتبع المخزون حسب رقم الدفعة وتاريخ انتهاء الصلاحية. يضمن ترتيب LIFO / FEFO الصحيح في كل عملية صرف مخزون — بدون الحاجة إلى اختيار يدوي.",
        Expiryalerts: "تنبيهات انتهاء الصلاحية",
        Autonotifications: "إشعارات تلقائية",
        LIFOsorting: "ترتيب LIFO / FEFO",
        Smartstockflow: "تدفق مخزون ذكي",
        Perout: "صرف مخزون لكل دفعة",
        Precisiontracking: "تتبع دقيق",
        NeedsReview: "يحتاج إلى مراجعة",
        Pending: "قيد الانتظار",
        Rejected: "مرفوض",
        Approved: "تمت الموافقة",
        WaitingForApproval: "في انتظار الموافقة",
        WaitingForApprovalDesc: "سيقوم مالكك بمراجعة هذه الدفعة والموافقة عليها قريبًا.",
        BatchRejected: "تم رفض الدفعة",
        BatchRejectedDesc: "قام مالكك برفض هذه الدفعة.",
        Reason: "السبب",
        Approve: "موافقة",
        Reject: "رفض",
        ConfirmApproveTitle: "الموافقة على الدفعة",
        ConfirmRejectTitle: "رفض الدفعة",
        ConfirmApprovalAction: "هل أنت متأكد أنك تريد {action} هذه الدفعة؟ سيؤدي هذا الإجراء إلى تحديث حالتها.",
        ReasonOptional: "السبب (اختياري)",
        EnterReasonPlaceholder: "أدخل سببًا لـ {action} (اختياري)",
        Processing: "جارٍ المعالجة...",
        BatchActivatedSuccess: "تم تفعيل الدفعة بنجاح",
        BatchDeactivatedSuccess: "تم إلغاء تفعيل الدفعة بنجاح",
        BatchDeletedSuccess: "تم حذف الدفعة بنجاح",
        BatchApprovedSuccess: "تمت الموافقة على الدفعة بنجاح",
        BatchRejectedSuccess: "تم رفض الدفعة بنجاح",
        SearchByBatchName: "البحث حسب اسم الدفعة...",
        YesTurnOff: "نعم، إيقاف",
        KeepItOn: "إبقاءه قيد التشغيل"

    },
    CategoryNewL: {
        TotalCategories: "إجمالي الفئات",
        lastaddedcategory: "آخر فئة مضافة",
        acrossalltypes: "عبر جميع الأنواع",
        MostRecent: "الأحدث",
        YesD: "نعم، احذف",
        AllAssociated: "قد تتأثر جميع المنتجات المرتبطة"
    },
    OverDas: {
        movestockbetweenlocations: "نقل المخزون",
        no_activity_yet: "لا يوجد نشاط بعد",
        no_activity_sub: "المبيعات والمشتريات وحركات المخزون والمرتجعات ستظهر هنا في الوقت الفعلي.",
        make_first_sale: "إجراء أول عملية بيع",
        add_stock: "إضافة مخزون",
        all_stock_healthy: "جميع مستويات المخزون جيدة",
        all_stock_healthy_sub: "لا توجد عناصر على وشك النفاد. قم بتعيين الحد الأدنى للمنتجات لتلقي التنبيهات هنا.",
        set_stock_thresholds: "تعيين حدود المخزون",
        no_warehouses_setup: "لم يتم إعداد أي مستودعات",
        no_warehouses_setup_sub: "أضف مستودعاً لبدء تتبع مكان تخزين مخزونك وإدارة المواقع.",
        add_first_warehouse: "إضافة أول مستودع",
        Customer: "العملاء",
        PurchasevsSales: "المشتريات مقابل المبيعات",
        Financialperformancechart: "مخطط الأداء المالي",
        QuickActions: "إجراءات سريعة",
        Frequentlyused: "المستخدمة بشكل متكرر",
        Addinventory: "إضافة مخزون",
        Dispatchitems: "إرسال العناصر",
        Addorder: "إضافة طلب",
        Newitem: "عنصر جديد",
        Inventoryaccess: "الوصول إلى المخزون",
        Itemsneedingreorder: "العناصر التي تحتاج إلى إعادة الطلب",
        Latesttransactions: "آخر المعاملات",
        Operationalsummary: "ملخص العمليات",
        ViewAll: "عرض الكل",
        Manage: "إدارة",
        RecentActivity: "النشاط الأخير",
        LowStockAlerts: "تنبيهات المخزون المنخفض",
        Primary: "الأساسي",
        TotalWarehouses: "إجمالي المستودعات"
    },
    SerialLocal: {
        ShowOrHideFields: "إظهار أو إخفاء الحقول",
        ShowOrHideFieldsDesc: "انقر على أي عنصر أدناه لتضمينه أو إزالته من الفاتورة المطبوعة. يتم تطبيق التغييرات على الفور.",
        Manufacturesettings: "إعدادات التصنيع",
        Showbuyingprice: "إظهار سعر الشراء / تكلفة المنتج",
        Showadditionalcost: "إظهار التكلفة الإضافية",
        Costbreakdown: "تفاصيل التكلفة",
        Unitcost: "تكلفة الوحدة",
        Rawmaterialstotal: "إجمالي المواد الخام",
        Confirmentry: "تأكيد الإدخال",
        SaveSerials: "حفظ الأرقام التسلسلية",
        SerialNumber: "الرقم التسلسلي",
        selected: "تم اختياره",
        added: "تمت إضافته",
        Serialnumbers: "الأرقام التسلسلية",
        ResetAll: "إعادة تعيين الكل",
        Wecouldnfindthis: "لم نتمكن من العثور على أي أرقام تسلسلية متاحة لهذا المنتج.",
        Nounitsfound: "لم يتم العثور على وحدات",
        Searchingserialnumbers: "جاري البحث عن الأرقام التسلسلية...",
        Scanorenterstock: "امسح أو أدخل الأرقام التسلسلية للمخزون الجديد",
        Whataserialnumber: "ما هو الرقم التسلسلي؟",
        Auniqueidentifieryourinventorylifecycle: "معرف فريد لكل وحدة — يتيح لك تتبع كل عنصر على حدة خلال دورة حياة المخزون.",
        Trackedstockout: "خروج المخزون المتبع",
        Chooseexactlyselected: "اختر بالضبط أرقام السيريال التي تغادر. يتم عرض فقط السيريال المخزنة لهذا المنتج — الكمية تُقفل بمجرد اختيارك ",
        SelectSerialstoout: " - اختر الأرقام التسلسلية للخروج",
        Thisinvoicegeneratedusingwwwsimplstockco: "تم إنشاء هذه الفاتورة باستخدام www.simplstock.co",
        AuthorizedSignature: "التوقيع المعتمد",
        Invoicesettings: "إعدادات الفاتورة",
        Draw: "ارسم",
        Taptoselectordeselectitems: "اضغط لتحديد أو إلغاء تحديد العناصر",
        Thissignaturewillbeadded: "سيتم إضافة هذا التوقيع أسفل الفاتورة المطبوعة.",
        SignatureOptions: "خيارات التوقيع",
        Upload: "رفع",
        DrawSignature: "ارسم التوقيع",
        UploadSignature: "رفع التوقيع",
        Clear: "مسح",
        ShowStaffName: " اسم الموظف",
        ShowSKU: " SKU",
        ShowBusinessName: " اسم الشركة",
        ShowProductName: " اسم المنتج",
        ShowBusinessPhoneNumber: " رقم هاتف العمل",
        ShowBusinessEmail: " بريد العمل الإلكتروني",
        ShowBusinessAddress: " عنوان العمل",
        ShowProductImage: " صورة المنتج",
        ShowPaymentDetails: " تفاصيل الدفع",
        ShowCategory: " الفئة",
        ShowVariant: " النوع",
        ShowWarehouse: " المستودع",
        ShowAttributes: " الخصائص",
        ShowQuantity: " الكمية",
        ShowDiscount: " الخصم",
        ShowTax: " الضريبة",
        ShowPrice: " السعر",
        ShowTotalPrice: " السعر الإجمالي للمنتج",
        ShowExpenses: " المصروفات",
        ShowSignature: " التوقيع",
        ShowNote: " الملاحظة",
        showAttachment: " المرفق",
        ShowSerialNumber: " الرقم التسلسلي",
        Invoicesettingsapplied: "تم تطبيق إعدادات الفاتورة. تحقق من الفاتورة لمعرفة التغييرات.",
        EnterSerialNumber: "أدخل الرقم التسلسلي",
    },
    Bin: {
        Bin: "الخانة",
        Add: "إضافة",
        NoBinsAddedYet: "لم يتم إضافة أي خانات بعد",
        BinLocationsHelp: "مواقع الخانات تساعدك على تتبع المخزون حسب الموضع الدقيق داخل هذا المستودع — لا حاجة للبحث بعد الآن.",
        NameThemByPosition: "سمّها حسب الموقع:",
        AddBinLocation: "إضافة موقع خانة",
        BinLocations: "مواقع الخانات",
        BinNameRequired: "اسم الخانة مطلوب",
        EditBin: "تعديل الخانة",
        AddBin: "إضافة خانة",
        EnterBinName: "اسم الخانة",
        EnterBinNamePlaceholder: "أدخل اسم الخانة",
        BinStatus: "حالة الخانة",
        BinNotes: "ملاحظات",
        EnterBinNotesPlaceholder: "أضف بعض الملاحظات...",
        ViewInventory: "عرض المخزون",
        Inventory: "المخزون",
        TrymatchingadifferentSKUname: "حاول مطابقة SKU أو اسم مختلف.",
        Thisbinlocationcurrentlyempty: "موقع هذه الخانة فارغ حالياً.",
        Loadingbins: "جاري تحميل الخانات...",
        bins: "خانات",
        ManageBin: "إدارة الخانة",
        Print: "طباعة",
        SBin: "بن المصدر",
        DBin: "بن الوجهة"
    },
    WarehouseExcel: {
        title: "تحميل المستودعات ومواقع الخانات",
        description: "اتبع الخطوات أدناه لإنشاء المستودعات مع مواقع الخانات بالجملة باستخدام ملف Excel.",
        bulkUploadGuide: "دليل التحميل الجماعي",
        step1: "الخطوة 1",
        downloadTemplate: "تحميل قالب Excel",
        downloadTemplateDesc: "احصل على القالب الرسمي مع جميع رؤوس الأعمدة المطلوبة. لا تعدل أو تحذف أي عمود.",
        downloadTemplateBtn: "تحميل القالب",
        step2: "الخطوة 2",
        fillExcelFile: "املأ ملف Excel",
        fillExcelDesc: "كل صف يمثل مستودع واحد. املأ جميع الأعمدة — لمواقع الخانات، أدخل أسماء الخانات مفصولة بفواصل في عمود <code>Bin Names</code>.",
        step3: "الخطوة 3",
        thingsToKeepInMind: "أمور يجب مراعاتها",
        rulesDesc: "قبل التحميل، تأكد من أن ملفك يتبع هذه القواعد لتجنب الأخطاء.",
        step4: "الخطوة 4",
        uploadYourFile: "تحميل ملفك",
        uploadDesc: "بعد التعبئة، قم بتحميل الملف أدناه. سيقوم النظام بإنشاء جميع المستودعات ومواقع الخانات تلقائياً.",
        rules: ["صف واحد لكل مستودع فقط", "أسماء الخانات مفصولة بفواصل في خلية واحدة", "لا تعدل رؤوس الأعمدة", "يتم تخطي أسماء الخانات المكررة داخل المستودع", "رقم الهاتف مع رمز الدولة", "يقبل فقط ملفات .xlsx أو .xls"],
        dropFileHere: "أسقط ملف Excel هنا",
        supports: "يدعم .xlsx و .xls — الحد الأقصى 10 ميجابايت",
        chooseFileUpload: "اختر الملف وارفع",
        parsing: "جاري تحليل الملف...",
        invalidFileType: "نوع الملف غير صالح. يرجى رفع ملف Excel.",
        noData: "لم يتم العثور على بيانات في Excel",
        failedToRead: "فشل في قراءة ملف Excel",
        unableToRead: "غير قادر على قراءة الملف.",
        reviewTitle: "مراجعة بيانات المستودعات",
        reviewSubtitle: "المراجعة النهائية قبل الاستيراد إلى عملك.",
        changeFile: "تغيير الملف",
        rowsFound: "صفوف موجودة في الملف",
        cancel: "إلغاء",
        finalizeImport: "إنهاء واستيراد",
        importing: "جاري الاستيراد...",
        success: "تم بنجاح",
        allWarehouseUploadedSuccess: "تم تحميل جميع المستودعات بنجاح",
        failed: "فشل",
        bulkUploadFailed: "فشل التحميل الجماعي",
        error: "خطأ",
        binNamesNote: "في عمود <strong>Bin Names</strong>، أدخل جميع مواقع الخانات للمستودع في خلية واحدة مفصولة بفواصل — مثال: A1, A2, B1, RACK-01.",
        headers: { warehouseName: "اسم المستودع", email: "البريد الإلكتروني", phoneNumber: "رقم الهاتف", location: "الموقع", binNames: "أسماء الخانات" }
    },
    VariantTemplate: {
        VariantTemplates: "قوالب المتغيرات",
        Managereusablevariantpatterns: "إدارة أنماط المتغيرات القابلة لإعادة الاستخدام",
        BinTransferHistory: "سجل نقل الخانات",
        Trackmovementsacrossbins: "تتبع الحركات بين الخانات",
        SerialNumberHistory: "سجل الأرقام التسلسلية",
        Trackproductserialnumberactivity: "تتبع نشاط الأرقام التسلسلية للمنتجات",
        Period: "الفترة",
        Nohistoryfound: "لم يتم العثور على سجل",
        Searchserialnumbers: "البحث عن أرقام تسلسلية...",
        SerialNumbersHistory: "سجل الأرقام التسلسلية",
        Serialnumberhistoryglance: "نظرة عامة على سجل الأرقام التسلسلية.",
        Noserialnumbersfound: "لم يتم العثور على أرقام تسلسلية",
        Noactivityhistoryfound: "لم يتم العثور على سجل نشاط",
        Statussetto: "تم تعيين الحالة إلى",
        Timeline: "الجدول الزمني",
        Managereusableproductvariantpatterns: "إدارة أنماط المتغيرات القابلة لإعادة الاستخدام للمنتجات.",
        DeleteTemplate: "حذف القالب",
        Areyousureyouwanttemplate: "هل أنت متأكد أنك تريد حذف هذا القالب؟",
        CreateNewTemplate: "إنشاء قالب جديد",
        CreateTemplate: "إنشاء قالب",
        EditTemplate: "تعديل القالب",
        UnlimitedTemplates: "قوالب غير محدودة",
        CreateAsManyTemplates: "أنشئ أي عدد تريده من القوالب — ملابس، أحذية، إلكترونيات وغيرها.",
        PickWhileAddingProduct: "اختر أثناء إضافة المنتج",
        OpenTemplateLibrary: "افتح مكتبة القوالب واختر أسماء المتغيرات في ثوانٍ.",
        MixFromMultipleTemplates: "الجمع من قوالب متعددة",
        SelectFromMultipleTemplates: "اختر أسماء المتغيرات من أكثر من قالب لمنتج واحد — مرونة كاملة.",
        EditAnytime: "عدّل في أي وقت",
        RenameTemplatesAnytime: "أعد تسمية القوالب، أضف أو احذف أسماء المتغيرات متى تغير كتالوجك.",
        StayConsistent: "ابقَ متسقاً",
        SameVariantNamesAcrossAll: "نفس أسماء المتغيرات عبر جميع المنتجات. لا أخطاء إملائية، لا تكرار، لا تخمين.",
        BuildOnceUseEverywhere: "ابنِ مرة واحدة، استخدم في كل مكان",
        StopReEnteringVariantNames: "توقف عن إعادة إدخال أسماء المتغيرات نفسها لكل منتج. أنشئ قالبًا، عيّن أسماء المتغيرات له، وأعد استخدامه فورًا.",
        Updateexistingvariantcombinations: "تحديث تركيبات المتغيرات الحالية",
        Definenewvariantcombinations: "تعريف تركيبات متغيرات جديدة",
        TemplateName: "اسم القالب",
        AddVariantOptions: "إضافة خيارات المتغيرات",
        SmallMedium: "مثال: صغير، متوسط...",
        VariantsList: "قائمة المتغيرات",
        Nooptionsaddedyet: "لم تتم إضافة أي خيارات بعد",
        SaveTemplate: "حفظ القالب",
        egSizesColorsetc: "مثال: مقاسات التيشيرت، الألوان، إلخ.",
        Pleaseentertemplatename: "يرجى إدخال اسم القالب",
        Pleaseaddatleastonevariantoption: "يرجى إضافة خيار متغير واحد على الأقل",
        Templateupdatedsuccessfully: "تم تحديث القالب بنجاح",
        Templatecreatedsuccessfully: "تم إنشاء القالب بنجاح",
        Failedtosavetemplate: "فشل في حفظ القالب",
        Transfer: "نقل",
        Editassignment: "تعديل التعيين",
        Updateproductdetailsinbin: "تحديث تفاصيل المنتج في الخانة",
        Editinginbin: "جاري التعديل في الخانة",
        ConfirmUpdate: "تأكيد التحديث",
        ConfirmAssign: "تأكيد التعيين",
        Assignanotherproduct: "تعيين منتج آخر",
        TransferBin: "نقل الخانة",
        SourceBin: "الخانة المصدر",
        DestinationBin: "الخانة الوجهة",
        SelectSourceBin: "اختر الخانة المصدر",
        SelectDestinationBin: "اختر الخانة الوجهة",
        Unit: "الوحدة",
        ManageVariant: "إدارة المتغير",
        CreateSKUvariationsyourproduct: "إنشاء اختلافات SKU لمنتجك",
        Assigningvariationsto: "تعيين الاختلافات إلى",
        Novariantsaddedyet: "لم تتم إضافة أي متغيرات بعد",
        AddedVariants: "المتغيرات المضافة",
        AddVariantsfromTemplate: "إضافة متغيرات من قالب",
        Pickatemplateandselectvariantnames: "اختر قالبًا وحدد أسماء المتغيرات",
        ChooseaTemplate: "اختر قالبًا",
        Selectvariantnamestoadd: "حدد أسماء المتغيرات لإضافتها",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "اختر قالبًا لاختيار أسماء المتغيرات منه. يمكنك الإضافة من عدة قوالب.",
        Loadingtemplates: "جاري تحميل القوالب...",
        Backtotemplates: "العودة إلى القوالب",
        Selectallindividualadd: "حدد الكل أو أسماء المتغيرات الفردية لإضافتها.",
        VariantNames: "أسماء المتغيرات",
        MediaDescription: "الوسائط والوصف",
        Addattachmentsandproductnotes: "إضافة مرفقات وملاحظات المنتج",
        ProductMedia: "وسائط المنتج"
    },
    AddProductGuide: {
        title: "إضافة الكمية الأولية بعد الحفظ",
        description: "لا تحتوي المنتجات على حقل كمية هنا. بعد الحفظ، استخدم 'إضافة المخزون' لتسجيل المخزون الافتتاحي — مع تحكم كامل في الموقع والتتبع.",
        steps: {
            quantity: { title: "الكمية", sub: "تعيين عدد المخزون الافتتاحي" },
            binLocation: { title: "موقع الخانة", sub: "ممر، رف، رف — مثال: A-01-03" },
            serialNumbers: { title: "الأرقام التسلسلية", sub: "تتبع كل وحدة على حدة" },
            warehouse: { title: "المستودع", sub: "الموقع الذي يتم تخزينه فيه" },
            batchExpiry: { title: "الدفعة / انتهاء الصلاحية", sub: "تجميع المخزون حسب رقم الدفعة" }
        },
        actions: { close: "إغلاق" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "لم يتم العثور على أوامر نقل",
        Itemshistory: "العناصر التي تنقلها بين المستودعات ستظهر هنا للتتبع والسجل.",
        CreateTransfer: "إنشاء نقل"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "اضغط على المنتج للتصنيع",
        Selectproductfrombelow: "اختر منتجاً من القائمة أدناه",
        SetupANewProduct: "إعداد منتج جديد",
        DefineAProductAdditsrawmaterial: "تعريف منتج وإضافة مواده الخام",
        ManufacturingSetup: "إعداد التصنيع",
        Pickproducttodefineitsproductiondetails: "اختر منتجاً لتحديد تفاصيل إنتاجه",
        ConfigureManufacturing: "تكوين التصنيع",
        SelectRawMaterial: "اختر المادة الخام",
        NoRawMaterials: "لا توجد مواد خام",
        Definecomponentsneededtoproduct: "تحديد المكونات اللازمة لتصنيع هذا المنتج.",
        NoAdditionalCosts: "لا توجد تكاليف إضافية",
        Addlaboroverheadlogisticalcharges: "أضف تكاليف العمالة أو العامة أو اللوجستية.",
        AddAdditionalCost: "إضافة تكلفة إضافية",
        AddCost: "إضافة تكلفة",
        TotalPrice: "السعر الإجمالي",
        SelectCharges: "اختر الرسوم",
        EnterEstimatedCost: "أدخل التكلفة التقديرية",
        QtyRequried: "الكمية المطلوبة",
        Manufacturing: "التصنيع",
        Outputfinishedgoodsdestination: "وجهة المنتجات النهائية",
        Manufacturingquantity: "كمية التصنيع",
        Storefinishedgoodsat: "تخزين المنتجات النهائية في",
        Rawmaterials: "المواد الخام",
        StockSelection: "اختيار المخزون",
        AdditionalCosts: "التكاليف الإضافية",
        Quantityconsume: "الكمية المستهلكة",
        Totalmanufacturingcost: "إجمالي تكلفة التصنيع",
        Sumofrawmaterialcosts: "مجموع تكاليف المواد الخام",
        CustomManufacturingCharge: "رسوم التصنيع المخصصة",
        Addextralikelaboroverheadrepairs: "أضف تكاليف إضافية كالعمالة والمصاريف العامة والإصلاحات.",
        CalculatedTotal: "الإجمالي المحسوب",
        AddRawMaterial: "إضافة مادة خام",
        ConfigureRawMaterial: "تكوين المادة الخام",
        Thisoutputunit: "هذه هي الكمية الأساسية المطلوبة لكل وحدة إنتاج.",
        ChangeProduct: "تغيير المنتج",
        AddtoList: "إضافة إلى القائمة",
        ManufacturedSuccessfully: "تم التصنيع بنجاح",
        Manufacture: "تصنيع",
        EditDeleteHistory: "سجل التعديل/الحذف",
        ManageOrder: "إدارة الطلب",
        ManageBatch: "إدارة الدفعة",
        Paymentnotavailablehere: "الدفع غير متاح هنا",
        Thisrecordisanorderorderitself: "هذا السجل من طلب. يمكن تسجيل الدفع من الطلب نفسه فقط.",
        Torecorpaymenttheorderthethere: "لتسجيل الدفع، انتقل إلى الطلب المرتبط واستخدم خيار <b>تسجيل الدفع</b> هناك.",
        GotoOrder: "الذهاب إلى الطلب"
    },
    CustomerExcel: {
        title: "تحميل العملاء",
        description: "اتبع الخطوات أدناه لإنشاء عملاء بشكل جماعي باستخدام ملف Excel.",
        bulkUploadGuide: "دليل التحميل الجماعي",
        step1: "الخطوة 1",
        downloadTemplate: "تحميل قالب Excel",
        downloadTemplateDesc: "احصل على القالب الرسمي مع جميع عناوين الأعمدة المطلوبة مسبقاً.",
        downloadTemplateBtn: "تحميل القالب",
        step2: "الخطوة 2",
        fillExcelFile: "ملء ملف Excel",
        fillExcelDesc: "كل صف يمثل عميلاً واحداً. املأ جميع الأعمدة حسب المطلوب.",
        step3: "الخطوة 3",
        thingsToKeepInMind: "أشياء يجب وضعها في الاعتبار",
        rulesDesc: "قبل التحميل، تأكد من أن ملفك يتبع هذه القواعد لتجنب الأخطاء.",
        step4: "الخطوة 4",
        uploadYourFile: "تحميل ملفك",
        uploadDesc: "بمجرد الملء، قم بتحميل الملف أدناه. سيقوم النظام بإنشاء جميع العملاء تلقائياً.",
        rules: [
            "صف واحد لكل عميل فقط",
            "لا تقم بتغيير أسماء عناوين الأعمدة",
            "رقم جهة الاتصال مع رمز الدولة",
            "يتم قبول ملفات .xlsx أو .xls فقط"
        ],
        dropFileHere: "اسحب ملف Excel هنا",
        supports: "يدعم .xlsx و .xls — بحد أقصى 10 ميجابايت",
        chooseFileUpload: "اختر ملفاً وقم بالتحميل",
        parsing: "جاري تحليل الملف...",
        invalidFileType: "نوع ملف غير صالح. يرجى تحميل ملف Excel.",
        noData: "لم يتم العثور على بيانات في Excel",
        failedToRead: "فشل في قراءة ملف Excel",
        unableToRead: "غير قادر على قراءة الملف.",
        reviewTitle: "مراجعة بيانات العملاء",
        reviewSubtitle: "الفحص النهائي قبل الاستيراد إلى عملك.",
        changeFile: "تغيير الملف",
        rowsFound: "صفوف موجودة في الملف",
        cancel: "إلغاء",
        finalizeImport: "إنهاء واستيراد",
        importing: "جاري الاستيراد...",
        success: "نجاح",
        allCustomerUploadedSuccess: "تم تحميل جميع العملاء بنجاح",
        failed: "فشل",
        bulkUploadFailed: "فشل التحميل الجماعي",
        error: "خطأ",
        headers: {
            customerName: "اسم العميل",
            phoneNumber: "جهة الاتصال",
            address: "العنوان",
            note: "ملاحظة"
        }
    },
    SupplierExcel: {
        title: "تحميل الموردين",
        description: "اتبع الخطوات أدناه لإنشاء موردين بشكل جماعي باستخدام ملف Excel.",
        bulkUploadGuide: "دليل التحميل الجماعي",
        step1: "الخطوة 1",
        downloadTemplate: "تحميل قالب Excel",
        downloadTemplateDesc: "احصل على القالب الرسمي مع جميع عناوين الأعمدة المطلوبة مسبقاً.",
        downloadTemplateBtn: "تحميل القالب",
        step2: "الخطوة 2",
        fillExcelFile: "ملء ملف Excel",
        fillExcelDesc: "كل صف يمثل مورداً واحداً. املأ جميع الأعمدة حسب المطلوب.",
        step3: "الخطوة 3",
        thingsToKeepInMind: "أشياء يجب وضعها في الاعتبار",
        rulesDesc: "قبل التحميل، تأكد من أن ملفك يتبع هذه القواعد لتجنب الأخطاء.",
        step4: "الخطوة 4",
        uploadYourFile: "تحميل ملفك",
        uploadDesc: "بمجرد الملء، قم بتحميل الملف أدناه. سيقوم النظام بإنشاء جميع الموردين تلقائياً.",
        rules: [
            "صف واحد لكل مورد فقط",
            "لا تقم بتغيير أسماء عناوين الأعمدة",
            "رقم جهة الاتصال مع رمز الدولة",
            "يتم قبول ملفات .xlsx أو .xls فقط"
        ],
        dropFileHere: "اسحب ملف Excel هنا",
        supports: "يدعم .xlsx و .xls — بحد أقصى 10 ميجابايت",
        chooseFileUpload: "اختر ملفاً وقم بالتحميل",
        parsing: "جاري تحليل الملف...",
        invalidFileType: "نوع ملف غير صالح. يرجى تحميل ملف Excel.",
        noData: "لم يتم العثور على بيانات في Excel",
        failedToRead: "فشل في قراءة ملف Excel",
        unableToRead: "غير قادر على قراءة الملف.",
        reviewTitle: "مراجعة بيانات الموردين",
        reviewSubtitle: "الفحص النهائي قبل الاستيراد إلى عملك.",
        changeFile: "تغيير الملف",
        rowsFound: "صفوف موجودة في الملف",
        cancel: "إلغاء",
        finalizeImport: "إنهاء واستيراد",
        importing: "جاري الاستيراد...",
        success: "نجاح",
        allSupplierUploadedSuccess: "تم تحميل جميع الموردين بنجاح",
        failed: "فشل",
        bulkUploadFailed: "فشل التحميل الجماعي",
        error: "خطأ",
        headers: {
            supplierName: "اسم المورد",
            phoneNumber: "جهة الاتصال",
            bankName: "اسم البنك",
            accountHolderName: "اسم صاحب الحساب",
            accountNumber: "رقم الحساب",
            note: "ملاحظة"
        }
    },
    ReplaceReturnLocal: {
        BuyingPrice: "سعر الشراء",
        SellingPrice: "سعر البيع",
        ReplacedWith: "تم الاستبدال بـ",
        Noreplacementhistoryfound: "لم يتم العثور على سجل استبدال",
        Noreturnhistoryfound: "لم يتم العثور على سجل إرجاع",
        Productbeingreturned: "المنتج الذي يتم إرجاعه",
        Required: "مطلوب",
        Selectreturnedproduct: "اختر المنتج المراد إرجاعه",
        Searchnamescanbarcode: "ابحث بالاسم أو SKU أو امسح الباركود",
        Browse: "تصفح",
        Stockhandling: "معالجة إدخال المخزون",
        Stockinreturnedproduct: "إدخال المنتج المرتجع إلى المخزون",
        Ontoinventory: "تشغيل — سيتم إعادة إضافة المنتج إلى المخزون",
        Offreturnedonly: "إيقاف — سيتم تسجيل المنتج كمرتجع فقط",
        Usedrestock: "يُستخدم لحساب تعديل الربح عند إعادة التخزين",
        Willaddedbackconfirmation: "سيتم إعادة إضافته إلى المخزون عند التأكيد",
        Returnreason: "سبب الإرجاع",
        Optional: "اختياري",
        SelectReason: "اختر السبب",
        Additionalnotes: "ملاحظات إضافية",
        Describeofcustomerexplanation: "صف حالة المنتج المرتجع، أي تلف مرئي، أو شرح العميل...",
        Requiredmustfilledcontinue: "يجب ملء الحقول المطلوبة للمتابعة",
        Reviewdetailsbeforeconfirming: "راجع التفاصيل قبل التأكيد",
        Replacementproductwilldeductedinventoryconfirmation: "سيتم خصم المنتج البديل من مخزونك عند التأكيد.",
        Choosereplacementproduct: "اختر المنتج البديل",
        Willdeductedfrominventoryconfirm: "سيتم خصمه من المخزون عند التأكيد",
        Thesewillattachedothereturnrecord: "سيتم إرفاق هذه الصور بسجل الإرجاع",
        Replacementitem: "المنتج البديل",
        Addanotherproduct: "إضافة منتج آخر",
        Replacementproductwillbe: "سيتم",
        deducted: "خصم",
        fromyourinventoryconfirmation: "المنتج البديل من مخزونك عند التأكيد.",
        productadjustedusingprice: "سيتم إعادة تخزين المنتج المرتجع وتعديل الربح باستخدام سعر البيع الأصلي.",
        Willloggedreturnedonlynotrestocked: "سيتم تسجيله كمرتجع فقط — لن يتم إعادة تخزينه",
        Returnonly: "إرجاع فقط",
        Imagesofreturnedproduct: "صور المنتج المرتجع",
        Returnedproductwill: "المنتج المرتجع",
        not: "لن",
        berestockedloggedreturnedonly: "يُعاد تخزينه — سيتم تسجيله كمرتجع فقط.",
        AddImage: "إضافة صورة",
        STOCKIN: "إدخال إلى المخزون",
        LOGONLY: "تسجيل فقط",
        ContinuetoReview: "متابعة إلى المراجعة →",
        Confirmreplacement: "تأكيد الاستبدال",
        Confirmreturn: "تأكيد الإرجاع",
        Filldetailsbelowproceed: "املأ التفاصيل أدناه للمتابعة",
        Review: "مراجعة",
        editdetails: "تعديل التفاصيل",
        Configurereturndetails: "تكوين تفاصيل الإرجاع",
        Configurereplacementdetails: "تكوين تفاصيل الاستبدال",
        SelectSource: "اختر المصدر",
        Returning: "جاري الإرجاع",
        Replacement: "الاستبدال",
        WalkCustomer: "عميل مباشر",
        RETURNEDPRODUCT: "المنتج المرتجع",
        REPLACEMENTPRODUCT: "منتج الاستبدال",
        STOCKOUT: "إخراج من المخزون",
        Netinventoryimpact: "التأثير الصافي على المخزون",
        Replacementitemcost: "تكلفة المنتج البديل",
        Returneditemrestockvalue: "قيمة إعادة تخزين المنتج المرتجع",
        PROFITINVENTORYSUMMARY: "ملخص الربح والمخزون",
        Inventoryaction: "إجراء المخزون",
        Valuededucted: "القيمة المخصومة",
        Profitadjustment: "تعديل الربح",
        stockedout: " تم إخراجه من المخزون",
        restocked: " تم إعادة تخزينه",
        Noaction: "لا يوجد إجراء",
        Valuebeingreturned: "القيمة التي يتم إرجاعها",
        Willberestocked: "سيتم إعادة تخزينه",
        Willbe: "سيتم",
        logged: "تسجيله",
        ON: "تشغيل",
        OFF: "إيقاف",
        Linked: "مرتبط",
        Pleaseselectreturnedproduct: "يرجى اختيار منتج مرتجع",
        Quantityrequired: "الكمية مطلوبة",
        Buyingpricerequired: "سعر الشراء مطلوب",
        Pleaseaddleastreplacementproduct: "يرجى إضافة منتج استبدال واحد على الأقل",
        Pleaseconfigurereturnedproductdetails: "يرجى تكوين تفاصيل المنتج المرتجع",
        Pleaseselectcustomer: "يرجى اختيار العميل",
        Returndateisrequired: "تاريخ الإرجاع مطلوب",
        Pleasefillallrequiredfields: "يرجى ملء جميع الحقول المطلوبة",
        Wildeductedfrominventory: "سيتم خصمه من المخزون",
        Currentprice: "السعر الحالي",
        Defectivedamaged: "معيب / تالف",
        Wrongitemreceived: "تم استلام منتج خاطئ",
        Customerchangedmind: "غيّر العميل رأيه",
        Sizefitissue: "مشكلة في المقاس / الملاءمة",
        Notasdescribed: "لا يطابق الوصف",
        Other: "أخرى",
        Originalsaleprice: "السعر الأصلي للبيع (مع تعديل الربح)",
        Addedbackinventory: "تمت إضافته مرة أخرى إلى المخزون",
        Notaddedinventory: "لم تتم إضافته إلى المخزون",
        replacedwith: "استبدل بـ",
        deductedfrominventory: "تم خصمه من المخزون",
        RETURNWITHSTOCKIN: "إرجاع · مع إدخال المخزون",
        RETURNNOSTOCKIN: "إرجاع · بدون إدخال المخزون",
        MULTIPLEREPLACEMENTS: "استبدالات متعددة",
        SINGLEREPLACEMENT: "استبدال واحد",
        InternalTrackingRecordInfo: "هذا سجل للتتبع الداخلي. لا تقوم هذه العملية تلقائيًا بتحديث أو حذف الفواتير أو الطلبات أو الحسابات ذات الصلة.",
        ManualStepsIfNeeded: "الخطوات اليدوية (إذا لزم الأمر):",
        ManualStep1: "إرجاع/حذف الفاتورة من سجل المبيعات",
        ManualStep2: "ضبط دفتر أستاذ العميل يدويًا",
        ManualStep3: "تحديث سجل الشراء ذي الصلة",
        RETURNEDSTOCKIN: "مُرجع · مخزون داخل",
        REPLACEMENTSTOCKOUT: "استبدال · مخزون خارج",
        Returnonlylogsthisentry: "الإرجاع يسجل هذه الإدخال فقط —",
        nostockwillbeaddedorremoved: "لن يتم إضافة أو إزالة أي مخزون",
        frominventory: "من المخزون.",
        Whentousethis: "متى تستخدم هذا:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "استخدم الإرجاع في نهاية اليوم لتسجيل العناصر المرسلة للمبيعات والتي عادت تالفة أو غير صالحة للاستخدام — العناصر التي تريد تتبعها ولكن لا يمكنك إعادتها إلى المخزون.",
        Youcanviewallpastreturnentriesin: "يمكنك عرض جميع إدخالات الإرجاع السابقة في",
        ReturnHistory: "سجل الإرجاع",
        underthe: "تحت تبويب",
        Others: "آخرون",
        tab: ".",
        Negativestocktransactiondisabled: "المعاملات السلبية للأسهم معطلة."
    },
    NewRLocal: {
        Originalsaleprice: "سعر البيع الأصلي",
        Editinghistoryonlyinventorystaysunchanged: "تعديل السجل فقط — يبقى المخزون دون تغيير.",
        Changeshereupdatethisdetailsquantitiesaffected: "التغييرات هنا تحدث تفاصيل هذا السجل (السبب، التاريخ، الملاحظات) فقط. لا تتأثر كميات المخزون الفعلية، مواقع الخانات، وبيانات المنتج.",
        Needtofixinventorylevelsinstead: "هل تحتاج إلى إصلاح مستويات المخزون بدلاً من ذلك؟",
        AdjustStock: "ضبط المخزون",
        Refund: "إرجاع المبلغ",
        ImportantNote: "ملاحظة مهمة",
        Pleasereviewbeforecontinuing: "يرجى المراجعة قبل المتابعة",
        Onceshippedreceivedanyupdatesmadeorder: "بمجرد شحن الطلب أو استلامه، لن تنعكس أي تحديثات يتم إجراؤها على الطلب في سجل المعاملات.",
        Thisundone: "سيؤدي هذا إلى حذف الطلب بشكل دائم. لا يمكن التراجع عن هذا الإجراء.",
        Inventorywilladjustedautomatically: "لن يتم تعديل المخزون تلقائيًا",
        Deletingthisreversevedshippedyouwillneed: "حذف هذا الطلب لا يعكس أي تغييرات في المخزون. إذا تم استلام/شحن العناصر بالفعل، فستحتاج إلى",
        reflectthecorrectstocklevels: "لإظهار مستويات المخزون الصحيحة.",
        manuallyadjustyourinventory: "ضبط مخزونك يدويًا",
        Addremovestockforitemsthatwereshipped: "إضافة أو إزالة المخزون للعناصر التي تم شحنها",
        Addremovestockforitemsthatwerereceived: "إضافة أو إزالة المخزون للعناصر التي تم استلامها",
        Updatecostrecordspaymentwaalreadymade: "تحديث سجلات التكلفة إذا تم دفع المبلغ بالفعل",
        Reconcilerecordsandoutstandingpayments: "تسوية السجلات والمدفوعات المعلقة"
    },
    ReceivablesLocal: {
        Receivables: "المستحقات",
        Manageandtrackcustomerduebalances: "إدارة وتتبع أرصدة العملاء المستحقة",
        Viewcustomerduebalancereport: "عرض تقرير رصيد العملاء المستحق",
        Viewsupplierduebalancereport: "عرض تقرير رصيد الموردين المستحق",
        DueBalance: "الرصيد المستحق",
        Unpaid: "غير مدفوع",
        PartiallyPaid: "مدفوع جزئياً",
        Paid: "مدفوع",
        HighestBalance: "أعلى رصيد",
        LowestBalance: "أدنى رصيد",
        Filldetailsrecordpayment: "املأ التفاصيل لتسجيل الدفعة",
        NewPaymentEntry: "إدخال دفعة جديدة",
        EditPaymentEntry: "تعديل إدخال الدفعة",
        Nosuppliersfound: "لم يتم العثور على موردين",
        Nocustomersfound: "لم يتم العثور على عملاء",
        LowtoHigh: "من الأقل إلى الأعلى",
        HightoLow: "من الأعلى إلى الأقل",
        AttachmentUploadedSc: "تم رفع المرفق بنجاح",
        AttachmentUploadedF: "فشل في رفع المرفق",
        Pay: "ادفع",
        NoBillsFound: "لم يتم العثور على فواتير",
        Thiscustomerhasunpaidbills: "ليس لدى هذا العميل فواتير غير مدفوعة.",
        TotalDue: "إجمالي المستحق",
        BillsFound: "تم العثور على فواتير",
        DeselectAll: "إلغاء تحديد الكل",
        SelectAll: "تحديد الكل",
        ShowDetails: "إظهار التفاصيل"
    },
    AssetsNewLocal: {
        Assignedon: "تم التعيين في",
        Total: "الإجمالي",
        Assigned: "تم التعيين",
        Remaining: "المتبقي",
        Available: "متوفر",
        NoSerialNumbers: "لا توجد أرقام تسلسلية",
        UpdateExistingAssetDetails: "تحديث تفاصيل الأصول الحالية",
        RegisterNewBusinessAsset: "تسجيل أصل تجاري جديد",
        BasicInformation: "معلومات أساسية",
        AssetDetails: "تفاصيل الأصول",
        Quantity: "الكمية",
        SerialNumbers: "الأرقام التسلسلية",
        SerialNumberPlaceholder: "الرقم التسلسلي",
        AddSerialNumber: "إضافة رقم تسلسلي",
        SerialNumbersOptional: "الأرقام التسلسلية اختيارية. يمكنك إضافة ما يصل إلى",
        AssetImages: "صور الأصول",
        AdditionalNotes: "ملاحظات إضافية",
        AdditionalNotesPlaceholder: "أي تفاصيل إضافية أو سجل الصيانة...",
        Updating: "جاري التحديث...",
        Adding: "جاري الإضافة...",
        ITEquipmentPlaceholder: "مثل معدات تقنية المعلومات",
        LoadingMoreActivities: "جاري تحميل المزيد من الأنشطة...",
        AssignedAssets: "الأصول المخصصة",
        Noassetsassignedstaffmember: "لا توجد أصول مخصصة لهذا الموظف.",
        Assignassetstaff: "تعيين أصل للموظف",
        Returnassetfromstaff: "إرجاع هذا الأصل من الموظف",
        AssignmentDetails: "تفاصيل التخصيص",
        Serial: "رقم تسلسلي",
        ViewAssets: "عرض جميع الأصول",
        ViewByStaff: "عرض حسب الموظف",
        AssignedHistory: "سجل التخصيص",
        Returned: "تم الإرجاع",
        Returnedon: "تم الإرجاع في",
        ReturnedBy: "تم الإرجاع بواسطة",
        AssignedTo: "مخصص إلى",
        NoHistoryRecords: "لا توجد سجلات تاريخية",
        Selectstaffmemberviewtheirassets: "اختر موظفًا لعرض أصوله",
        Deleted: "محذوف",
        searchPlaceholder: "البحث عن الأصل بالاسم أو الرقم التسلسلي..."
    },
    InventoryCountLocale: {
        InventoryCount: "جرد المخزون",
        Viewinventorycountreport: "عرض تقرير جرد المخزون",
        ItemsCount: "عدد العناصر",
        All: "الكل",
        InProgress: "قيد التنفيذ",
        Submitted: "تم الإرسال",
        awaitingreview: "في انتظار المراجعة",
        EditInventoryCount: "تعديل جرد المخزون",
        NewInventoryCount: "جرد مخزون جديد",
        Modifyinventorycountsheetdetails: "تعديل تفاصيل ورقة جرد المخزون",
        Startanewinventorycountsheet: "بدء ورقة جرد مخزون جديدة",
        GeneralInformation: "معلومات عامة",
        Title: "العنوان",
        SaveChanges: "حفظ التغييرات",
        Selectproductsforthisinventorycountsheet: "اختر المنتجات لهذه الورقة",
        InventoryCountDetails: "تفاصيل جرد المخزون",
        Inventorycountsheetdetails: "تفاصيل ورقة جرد المخزون",
        Viewingdetailsforcountsheet: "عرض تفاصيل ورقة الجرد",
        Started: "بدأ",
        TaskSheets: "أوراق المهام",
        Allitems: "جميع العناصر",
        NotStarted: "لم يبدأ",
        Completed: "مكتمل",
        Results: "النتائج",
        ViewResults: "عرض النتائج",
        DeleteInventoryCount: "حذف جرد المخزون",
        Viewingtransactionandadjustments: "عرض سجلات المعاملات وتعديلات المخزون",
        Productsadjusted: "المنتجات المعدلة",
        Assignee: "المكلف",
        Tasksheetdetails: "تفاصيل ورقة المهمة",
        Draft: "مسودة",
        VariantQuantities: "كميات المتغيرات",
        AssignedProducts: "المنتجات المخصصة",
        ReturnAsset: "إرجاع الأصل",
        EditTasksheet: "تعديل ورقة المهمة",
        NewTasksheet: "ورقة مهمة جديدة",
        Updatetasksheetdetails: "تحديث تفاصيل ورقة المهمة",
        Starttasksheetforthisinventorycount: "ابدأ ورقة مهمة جديدة لهذا الجرد",
        TaskSheetInformation: "معلومات ورقة المهمة",
        SheetTitle: "عنوان الورقة",
        Entersheettitle: "أدخل عنوان الورقة",
        SubmissionResult: "نتيجة التقديم",
        ReviewChanges: "مراجعة التغييرات",
        Viewingsubmissionresultsforthisinventorycount: "عرض نتائج التقديم لهذا الجرد",
        Reviewyourinventorycountbeforesubmitting: "راجع جرد المخزون قبل التقديم"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "فشل في تحميل العد",
        NoInventoryCounts: "لا توجد جردات مخزون",
        NoMatches: "لا توجد مطابقات",
        Therearenoinventorycountswiththestatus: "لا توجد جردات مخزون بالحالة",
        Noinventorycountsfoundyoursearchterm: "لم يتم العثور على أي جردات مخزون مطابقة للبحث",
        Thereareinventorycountsrecordedyetforthisbusiness: "لا توجد جردات مخزون مسجلة بعد لهذا العمل"
    },
    StockinModalP: {
        StockInNow: "إدخال المخزون الآن",
        Settheopeningquantityforthisproductrightnow: "حدد الكمية الافتتاحية لهذا المنتج الآن.",
        Addinitialstock: "إضافة مخزون أولي؟",
        dothislater: "سأقوم بذلك لاحقاً",
        Productadded: "تمت إضافة المنتج!",
        isready: "جاهز.",
        SeeHowItWorks: "شاهد كيف يعمل",
        NoSalesOrdersFound: "لم يتم العثور على أوامر بيع",
        NoPurchaseOrdersFound: "لم يتم العثور على أوامر شراء",
        Startcreatingoutgoinginventoryrevenue: "ابدأ في إنشاء أوامر البيع لتتبع المخزون الصادر والإيرادات.",
        Trackrestockssupplierplace: "تتبع إعادة تخزين المخزون وطلبات الموردين في مكان واحد.",
        CreateSalesOrder: "إنشاء أمر بيع",
        CreatePurchaseOrder: "إنشاء أمر شراء",
    },
    dialy_report: "تقرير الحركة اليومية",
    Quotation: "عرض الأسعار",
    Quote: "عرض الأسعار",
    Assignee: "المكلف",
    dayStart: "بداية اليوم",

    ShowTotalAmount: "عرض المبلغ الإجمالي",

    tutorial: {
        watchTitle: 'مشاهدة البرامج التعليمية خطوة بخطوة',
        watchDesc: 'تعلم SimplyStock على قناتنا على YouTube',
        modalTitle: 'كن متقدمًا مع SimplyStock',
        modalDesc: 'اشترك للحصول على برامج تعليمية جديدة في اللحظة التي تسقط فيها',
        feature1Title: 'عرض تفصيلي للميزات الجديدة',
        feature1Sub: 'يتم شرح كل تحديث جديد بمقطع فيديو قصير — حتى لا يفوتك ما هو جديد',
        feature2Title: 'مقاطع فيديو إرشادية سريعة',
        feature2Sub: 'إعداد المخزون والفواتير وإمكانية وصول الموظفين والمزيد في أقل من 5 دقائق',
        feature3Title: 'إشعارات فورية',
        feature3Sub: 'احصل على إشعار في اللحظة التي يتم فيها بث برنامج تعليمي جديد — تعلم بالسرعة التي تناسبك',
        feature4Title: '100 ٪ مجانًا، دائمًا',
        feature4Sub: 'جميع البرامج التعليمية مجانية إلى الأبد — لا يلزم تسجيل الدخول أو الاشتراك',
        subscribeBtn: 'الاشتراك في SimplyStock',
        maybeLater: 'ربما لاحقًا'
    },
    dailyCashReport: {
        "title": "تقرير النقدية اليومي",
        "subtitle": "من دفع ماذا، في أي تاريخ، وما لا يزال مستحقًا — مجمعة من تفاصيل المبيعات.",
        "totalSales": "إجمالي المبيعات",
        "cashReceived": "إجمالي المستلم",
        "outstanding": "المستحقات",
        "collectionRate": "معدل التحصيل",
        "grandTotalAllDates": "الإجمالي الكلي (جميع التواريخ)",
        "totalLabel": "الإجمالي",
        "loading": "جاري التحميل...",
        "noData": "لا توجد بيانات للنطاق الزمني المحدد.",
        "loadingMore": "جاري تحميل المزيد..."
    },
    dailyCashReportColumns: {
        "date": "التاريخ",
        "customer": "العميل",
        "productsSold": "المنتجات المباعة",
        "products": "المنتجات",
        "salesAmount": "مبلغ المبيعات",
        "sales": "المبيعات",
        "received": "إجمالي المستلم",
        "receivedShort": "مستلم",
        "debited": "مدين لدفتر الأستاذ",
        "due": "مستحق",
        "paymentModes": "طرق الدفع",
        "mode": "الطريقة"
    },
}


export default ar
